import { ModuleType, RecordLine } from './../../layout/record-model';
import {
  Field,
  FieldDataType,
  ModuleInventoryDirection,
} from './../module-structure';
import { ModuleStructure, Section } from 'src/app/models/module-structure';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';
import { LayoutService } from 'src/app/layout/layout.service';
import {
  EventType,
  PriceQueueRequest,
  RecordCategory,
  RecordModel,
  RecordProperties,
} from 'src/app/layout/record-model';
import * as moment from 'moment';
import * as g from 'src/app/globals';
import { LineAddedArgs } from 'src/app/layout/line-added-args';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ScheduleSuggestionsComponent } from '@app/layout/record-page/custom-buttons/schedule-suggestions/schedule-suggestions.component';
import { Guid } from '../guid';

export class Documents {
  static reverseCalculation = false;
  static initialized = false;
  notNotified = true;
  dueDateShouldNotified = true;

  static validateBeforeSubmit(recordModel: RecordModel): string {
    /*if (recordModel.ObjectKey === 'oPickLists') {
      const pickLinesCat = recordModel.Categories.find(
        (x) => x.Id === 'PickLists_Lines'
      );

      pickLinesCat.Lines.forEach((element) => {
        const batchProp = element.Properties.find(
          (prop) => prop.Name === 'ITMSerialNumber'
        );
        const qtyProp = element.Properties.find(
          (p) => p.Name === 'PickedQuantity'
        );
        const relProp = element.Properties.find(
          (p) => p.Name === 'ReleasedQuantity'
        );
        const numPerUnitProp = element.Properties.find(
          (p) => p.Name === 'NumPerUnit'
        );
        qtyProp.ValueAsObject =
          Number(qtyProp.ValueAsObject) * Number(numPerUnitProp.ValueAsObject);

        relProp.ValueAsObject =
          Number(relProp.ValueAsObject) * Number(numPerUnitProp.ValueAsObject);
      });
    }*/
    if (recordModel.ModuleId === 10023) {
      const discountSection = recordModel.Categories.find(
        (x) => x.Id === 'Contract_Discount_Lines'
      );
      if (this.checkDiscountDateOverlap(discountSection)) {
        return 'There is an overlap between discounts';
      }
    }

    if (recordModel.ObjectKey === 'oQuotations') {
      // add new category with id = Document_SpecialLines
      // fill the lines base on cate SpecialLines
      // delete category SpecialLines
    }

    if (recordModel.ModuleType === ModuleType.CustomAction) {
      console.log('sdd');
      let categories: RecordCategory[];

      categories = recordModel.Categories.filter(
        (c) => c.Dataset !== undefined
      );
      categories.forEach((category) => {
        category.Lines = [];
        if (category.Dataset !== undefined) {
          category.Dataset.forEach((element) => {
            let newSectionAdded = false;
            if (!newSectionAdded) {
              let recordCategory: RecordCategory = null;
              recordCategory = {
                Id: category.Id,
                Lines: [],
                DeletedLines: [],
              };
              let recordLine: RecordLine = null;
              recordLine = {
                Id: recordCategory.Lines.length,
                Properties: [],
              };
              const recordProperty: RecordProperties = {
                DataType: FieldDataType.String,
                Name: 'LineData',
                FieldName: 'LineData',
                ValueAsObject: JSON.stringify(element),
              };
              recordLine.Properties.push(recordProperty);
              category.Lines.push(recordLine);

              // recordModel.Categories.push(recordCategory);
              newSectionAdded = true;
            }
          });
        }
      });
    } else if (recordModel.ObjectKey === 'oContacts') {
      let category: RecordCategory;

      category = recordModel.Categories.find(
        (c) => c.Id === 'BWEB_CHECKLIST_Questions'
      );
      if (category == null || category === undefined) {
        return '';
      }
      if (recordModel.TableSections !== undefined) {
        category.Dataset =
          recordModel.TableSections['BWEB_CHECKLIST_Questions'];
      }
    }
    return '';
  }

  static checkDiscountDateOverlap(discountSection: RecordCategory): boolean {
    for (let i = 0; i < discountSection.Lines.length; i++) {
      const element = discountSection.Lines[i];
      let toDateLine = element.Properties.find(
        (prop) => prop.Name === 'U_TO_DATE'
      ).ValueAsObject;

      toDateLine = new Date(toDateLine);

      let fromDateLine = element.Properties.find(
        (prop) => prop.Name === 'U_FROM_DATE'
      ).ValueAsObject;

      fromDateLine = new Date(fromDateLine);
      fromDateLine.setDate(1);

      for (let j = i + 1; j < discountSection.Lines.length; j++) {
        const element1 = discountSection.Lines[j];
        let fromDate = element1.Properties.find(
          (prop) => prop.Name === 'U_FROM_DATE'
        ).ValueAsObject;
        fromDate = new Date(fromDate);
        fromDate.setDate(1);

        let toDate = element1.Properties.find(
          (prop) => prop.Name === 'U_TO_DATE'
        ).ValueAsObject;

        toDate = new Date(toDate);

        if (
          fromDate.getTime() <= toDateLine.getTime() &&
          fromDate.getTime() >= fromDateLine.getTime()
        ) {
          return true;
        }

        if (
          toDate.getTime() <= toDateLine.getTime() &&
          toDate.getTime() >= fromDateLine.getTime()
        ) {
          return true;
        }

        if (
          fromDateLine.getTime() <= toDate.getTime() &&
          fromDateLine.getTime() >= fromDate.getTime()
        ) {
          return true;
        }

        if (
          toDateLine.getTime() <= toDate.getTime() &&
          toDateLine.getTime() >= fromDate.getTime()
        ) {
          return true;
        }
      }
    }

    return false;
  }

  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService,
    private modal: NzModalService,
    private listenToEvent: boolean = true
  ) {
    if (!listenToEvent) {
      return;
    }
    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      if (args.recordProperty === undefined) return;
      try {
        let additionalIdentifier = '';
        if (args.sectionTagName === 'Document_Lines') {
          const documentsSection = args.recordModel.Categories.find(
            (x) => x.Id === 'Documents'
          );

          const docTypeProp = documentsSection.Lines[0].Properties.find(
            (prop) => prop.Name === 'DocType'
          );

          if (docTypeProp != null && docTypeProp !== undefined) {
            if (docTypeProp.ValueAsObject === 'dDocument_Service') {
              additionalIdentifier = 'services';
            } else {
              additionalIdentifier = 'items';
            }
          }
        }
        const section = args.moduleStructure.module.Sections.find(
          (x) =>
            x.XmlTagName === args.sectionTagName &&
            (additionalIdentifier === '' ||
              (additionalIdentifier !== '' &&
                x.AdditionalIdentifier === additionalIdentifier))
        );
        let field = section.Fields.find(
          (f) => f.Id == args.recordProperty.FieldId
        );

        if (
          field !== undefined &&
          field.AdditionalInformationParsed.AffectFormMode
        ) {
          this.layoutService.recordModelChanged = true;
        }
        this.oDocuments(args);
      } catch (e) {
        console.error(
          'An error occurred while trying to execute oDocuments',
          args,
          e
        );
      }
    });

    layoutService.objectLoadChanged.subscribe(
      (args: {
        recordModel: RecordModel;
        moduleStructure: ModuleStructure;
      }) => {
        try {
          this.ObjectLoad(args.recordModel, args.moduleStructure);
          this.layoutService.recordModelChanged = false;
        } catch (e) {
          console.log('error during loading the object, the error is:', e);
        }
      }
    );

    this.layoutService.deleteRowEmitter.subscribe((args) => {
      try {
        const documentsCat = args.recordCategory;

        const documentsSection = args.moduleStructure.module.Sections.find(
          (x) => x.XmlTagName === args.recordCategory.Id
        );
        const saveCountInField =
          documentsSection.AdditionalInformationParsed.SaveCountIn;
        if (
          saveCountInField != null &&
          saveCountInField !== undefined &&
          saveCountInField !== ''
        ) {
          const paramSectionXmlTagName = saveCountInField.split('.')[0];
          const paramFieldPropertyName = saveCountInField.split('.')[1];

          const tempCat = args.recordModel.Categories.find(
            (x) => x.Id === paramSectionXmlTagName
          );
          tempCat.Lines[0].Properties.find(
            (p) => p.Name === paramFieldPropertyName
          ).ValueAsObject = documentsCat.Lines.length;
          tempCat.Lines[0].Properties.find(
            (p) => p.Name === paramFieldPropertyName
          ).Value = documentsCat.Lines.length.toString();
        }
      } catch (e) {
        console.log(
          'An error occured while trying to execute lineAdded',
          args,
          e
        );
      }
    });

    this.layoutService.lineAdded.subscribe((args: LineAddedArgs) => {
      try {
        const documentsCat = args.recordModel.Categories.find(
          (x) => x.Id === args.section.XmlTagName
        );
        const documentsSection = args.moduleStructure.module.Sections.find(
          (x) => x.XmlTagName === args.section.XmlTagName
        );
        const saveCountInField =
          documentsSection.AdditionalInformationParsed.SaveCountIn;
        if (
          saveCountInField != null &&
          saveCountInField !== undefined &&
          saveCountInField !== ''
        ) {
          const paramSectionXmlTagName = saveCountInField.split('.')[0];
          const paramFieldPropertyName = saveCountInField.split('.')[1];

          const tempCat = args.recordModel.Categories.find(
            (x) => x.Id === paramSectionXmlTagName
          );
          tempCat.Lines[0].Properties.find(
            (p) => p.Name === paramFieldPropertyName
          ).ValueAsObject = documentsCat.Lines.length + 1;
          tempCat.Lines[0].Properties.find(
            (p) => p.Name === paramFieldPropertyName
          ).Value = (documentsCat.Lines.length + 1).toString();
        }
      } catch (e) {
        console.log(
          'An error occured while trying to execute lineAdded',
          args,
          e
        );
      }
    });

    this.layoutService.lineDuplicated.subscribe((args: LineAddedArgs) => {
      try {
        const documentsSection = args.recordModel.Categories.find(
          (x) => x.Id === 'Documents'
        );

        const cardCodeEle = documentsSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'CardCode'
        );

        const _args: FieldValueChangedArgs = {
          recordModel: args.recordModel,
          recordProperty: cardCodeEle,
          formId: '',
          line: 0,
          sectionTagName: 'Documents',
          moduleStructure: args.moduleStructure,
        };

        this.oDocuments_TotalCalc(_args, true);
      } catch (e) {
        console.log(
          'An error occured while trying to execute lineAdded',
          args,
          e
        );
      }
    });
  }

  subscriptionReceivePaymentLoad(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure
  ) {
    const infoSection = recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );

    const selectedId = infoSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocEntry'
    ).ValueAsObject;

    const discountSection = recordModel.Categories.find(
      (x) => x.Id === 'Contract_Discount_Lines'
    );

    const summarySection = recordModel.Categories.find(
      (x) => x.Id === 'Payment_Summary'
    );

    summarySection.Lines[0].Properties.find(
      (prop) => prop.Name === 'PAY_DATE'
    ).ValueAsObject = new Date();

    let line = 0;
    discountSection.Lines.forEach((element) => {
      this.calculateLineTotals(selectedId, discountSection, line);
      line = line + 1;
    });
  }

  calculateLineTotals(
    selectedId: string,
    section: RecordCategory,
    line: number
  ) {
    const qty = section.Lines[line].Properties.find(
      (prop) => prop.Name === 'U_QTY'
    ).ValueAsObject;

    let fromDate = section.Lines[line].Properties.find(
      (prop) => prop.Name === 'U_FROM_DATE'
    ).ValueAsObject;

    const discountPercent = section.Lines[line].Properties.find(
      (prop) => prop.Name === 'U_DISC_VAL'
    ).ValueAsObject;

    fromDate = new Date(fromDate);

    this.layoutService
      .ExecuteGetDiscountLineValues(
        selectedId,
        qty,
        line,
        Number(discountPercent),
        this.formatDatetime(fromDate, g.companyConfiguration.MomentDateFormat)
      )
      .subscribe((d: any) => {
        if (d.HasError) {
        } else {
          section.Lines[line].Properties.find(
            (prop) => prop.Name === 'U_PRICE_BEFDI'
          ).ValueAsObject = d.BoxAMT;

          section.Lines[line].Properties.find(
            (prop) => prop.Name === 'U_PRICE_AFTDI'
          ).ValueAsObject = d.BoxAMT - (d.BoxAMT * discountPercent) / 100;

          section.Lines[line].Properties.find(
            (prop) => prop.Name === 'U_TOTAL_DI_PRD'
          ).ValueAsObject =
            d.OneShotAMT +
            qty * (d.BoxAMT - (d.BoxAMT * discountPercent) / 100);
        }
      });
  }

  ObjectLoad(recordModel: RecordModel, moduleStructure: ModuleStructure) {
    if (recordModel.ModuleId === 10028) {
      return;
    }

    if (!Documents.initialized) {
      Documents.initialized = true;
      this.layoutService
        .getConfiguration('config_reverse_calculation')
        .subscribe((data) => {
          if (data && data !== '') {
            Documents.reverseCalculation = data === 'Y';
          }
        });
    }
    // setTimeout(() => {
    //   const recordModelJson = JSON.stringify(recordModel);
    //   this.layoutService.pushDataToBackend(recordModelJson, 'SystemAdd')
    //     .subscribe((data) => {
    //       console.log('data', data);
    //     });
    // }, 2000);

    if (recordModel.ModuleId === 50019) {
      const reservedInvoice = recordModel.Categories.find(
        (f) => f.Id === 'Documents'
      ).Lines[0].Properties.find((f) => f.Name === 'ReserveInvoice');
      reservedInvoice.ValueAsObject = 'tYES';
      reservedInvoice.Value = 'tYES';
    }
    if (recordModel.ObjectKey === 'oPickLists') {
      // console.log('Pick List loaded >>', recordModel);
      const pickLinesCat = recordModel.Categories.find(
        (x) => x.Id === 'PickLists_Lines'
      );

      pickLinesCat.Lines.forEach((element) => {
        const batchProp = element.Properties.find(
          (prop) => prop.Name === 'ITMSerialNumber'
        );
        const qtyProp = element.Properties.find(
          (p) => p.Name === 'PickedQuantity'
        );
        const binAbs = element.Properties.find((p) => p.Name === 'BinAbs');
        const batchNumber = element.Properties.find(
          (p) => p.Name === 'BatchNumber'
        );

        const numPerUnitProp = element.Properties.find(
          (p) => p.Name === 'NumPerUnit'
        );

        if (
          binAbs.ValueAsObject != null &&
          binAbs.ValueAsObject !== undefined &&
          binAbs.ValueAsObject !== '' &&
          qtyProp.ValueAsObject != null &&
          qtyProp.ValueAsObject !== undefined &&
          qtyProp.ValueAsObject !== '' &&
          qtyProp.ValueAsObject !== '0' &&
          qtyProp.ValueAsObject !== 0
        ) {
          let batchValue =
            '{"Quantity":"' +
            Number(qtyProp.ValueAsObject) *
              Number(numPerUnitProp.ValueAsObject);
          batchValue += '","BinLocation":"' + binAbs.ValueAsObject;
          if (
            batchNumber.ValueAsObject != null &&
            batchNumber.ValueAsObject !== undefined &&
            batchNumber.ValueAsObject !== ''
          ) {
            batchValue += '","BatchNumber":"' + batchNumber.ValueAsObject;
          }
          batchValue += '"}';

          batchProp.ValueAsObject = batchValue;
        }
      });
    }

    if (
      recordModel.ObjectKey === 'COMPANY_CREATE' &&
      recordModel.EventType === EventType.Update
    ) {
      const companyCreationSection: Section =
        moduleStructure.module.Sections.find(
          (x) => x.XmlTagName === 'Company_Creation'
        );

      const companyUserSection: Section = moduleStructure.module.Sections.find(
        (x) => x.XmlTagName === 'Company_Creation_User'
      );

      const localization = companyCreationSection.Fields.find(
        (prop) => prop.FieldName === 'Localization'
      );

      const companyDBName = companyCreationSection.Fields.find(
        (prop) => prop.FieldName === 'CompanyDBName'
      );

      const newUserCode = companyUserSection.Fields.find(
        (prop) => prop.FieldName === 'NewUserCode'
      );

      const newUserName = companyUserSection.Fields.find(
        (prop) => prop.FieldName === 'NewUserName'
      );

      const newUserEmail = companyUserSection.Fields.find(
        (prop) => prop.FieldName === 'NewUserEmail'
      );

      const newUserPassword = companyUserSection.Fields.find(
        (prop) => prop.FieldName === 'NewUserPassword'
      );

      // const creationUser = recordModel.Categories.find(c => c.Id === 'Company_Creation_User').Lines[0];
      // creationUser.Properties[0].ReadOnly = true;

      localization.AdditionalInformationParsed.Visible = false;
      newUserCode.AdditionalInformationParsed.Visible = false;
      newUserName.AdditionalInformationParsed.Visible = false;
      newUserEmail.AdditionalInformationParsed.Visible = false;
      newUserPassword.AdditionalInformationParsed.Visible = false;
      companyUserSection.AdditionalInformationParsed.Hidden = true;

      companyDBName.ReadOnly = true;

      return;
    }

    const documentObjects = [
      'Expense_Object',
      'oInvoices',
      'oCorrectionInvoice',
      'oCorrectionInvoiceReversal',
      'oPurchaseRequest',
      'oCreditNotes',
      'oDeliveryNotes',
      'oReturns',
      'oOrders',
      'oQuotations',
      'oPurchaseInvoices',
      'oCorrectionPurchaseInvoice',
      'oCorrectionPurchaseInvoiceReversal',
      'oPurchaseCreditNotes',
      'oPurchaseDeliveryNotes',
      'oPurchaseReturns',
      'oPurchaseOrders',
      'oPurchaseQuotations',
      // 'oInventoryGenEntry',
      // 'oInventoryGenExit',
      'oDrafts',
      'oDownPaymentAP',
      'oDownPaymentAR',
      'oPurchaseDownPayments',
      'oDownPayments',
      'oReturnRequest',
    ];

    const found =
      documentObjects.findIndex((x) => x === recordModel.ObjectKey) > -1;

    //  if (!found || args.recordModel.ModuleId === 100008) {
    if (recordModel.ModuleId === 10024) {
      this.subscriptionReceivePaymentLoad(recordModel, moduleStructure);
      return;
    }
    if (!found) {
      return;
    }

    const action = recordModel.EventType;
    const currentObject = recordModel.ObjectTypeValue;
    const fromDraft = recordModel.FromDraft;
    const documentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const documentLinesSection = recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );

    if (action === EventType.Update) {
      const authProp = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'AuthStatus'
      );
      // .ValueAsObject;
      const statusProp = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'DocumentStatus'
      );
      // .ValueAsObject;

      if (fromDraft) {
        /*if ((auth == 'Y' || auth == '-') && (status == 'O' || status == 'bost_Open')) {
          if (auth !== '-')
            $(':input', form).prop('readonly', true);

          $('.form-actions button', form).prop('disabled', false);
          $('[name="Documents.DocDate"],[name="Documents.TaxDate"],[name="Documents.DocDueDate"]', form).prop('disabled', false);
          // $('.form-actions .col-md-12', form).prepend('<a href="#" class="btn btn-primary save-as-draft-button"
          onclick="oDocuments_Object.SaveDraftDocumentToFinal(this); return false;">Save the document</a>');
        }
        else {
          $('.save-to-final-doc', form).css('display', 'none');
        }*/
      }
    }

    const valueEle = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocType'
    );

    let value;
    if (valueEle !== undefined) {
      value = valueEle.ValueAsObject;
    }

    if (value !== undefined) {
      if (value === 'I') {
        for (const section of moduleStructure.module.Sections) {
          if (section.AdditionalIdentifier === 'services') {
            section.AdditionalInformationParsed.Hidden = true;
            break;
          }
        }
      } else {
        for (const section of moduleStructure.module.Sections) {
          if (section.AdditionalIdentifier === 'items') {
            section.AdditionalInformationParsed.Hidden = true;
            break;
          }
        }
      }
    }

    if (found) {
      const forceRecalc = recordModel.Categories.find(
        (c) => c.Id == 'Documents'
      ).Lines[0].Properties.find((p) => p.Name === 'ForceRecalculate')?.Value;
      if (forceRecalc === 'Y') {
        const lines = recordModel.Categories.find(
          (c) => c.Id === 'Document_Lines'
        ).Lines;
        const obj = this;
        lines.forEach((line) => {
          const unitPriceArgs: FieldValueChangedArgs = {
            line: line.Id,
            moduleStructure: moduleStructure,
            formId: '',
            recordModel: recordModel,
            recordProperty: line.Properties.find((p) => p.Name === 'UnitPrice'),
            sectionTagName: 'Document_Lines',
          };

          const grossPrice = obj.CalculateGrossPrice(unitPriceArgs);
          obj.SetGrossPrice(unitPriceArgs, grossPrice);
          obj.Document_UpdateRowTotal(unitPriceArgs, true);
        });
      }

      this.oDocuments_GetTotals(recordModel, moduleStructure, true);
      //  oDocuments_SetCurrencyLabel();

      /*$('[name="Document_Lines.Quantity"]', form).each(function () {
        $quantity = $(this);
        // oDocuments_Object.QtyChanged($quantity, false);
        oDocuments_Object.InitialSNBatchControls($quantity);
      });*/
      // <-- ----------Below was commented in order to fix an issue for tax rate in documents ---------- -->

      const cardCodeEle = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'CardCode'
      );

      const args: FieldValueChangedArgs = {
        recordModel,
        recordProperty: cardCodeEle,
        formId: '',
        line: 0,
        sectionTagName: 'Documents',
        moduleStructure,
      };

      this.oDocuments_TotalCalc(args, true);

      if (
        g.messageWhenEditingOrderQueryId !== 0 &&
        recordModel.ObjectKey === 'oOrders'
      ) {
        setTimeout(() => {
          this.layoutService
            .executeQuery(g.messageWhenEditingOrderQueryId, {
              CardCode: args.recordProperty.Value,
            })
            .subscribe((result: any[]) => {
              if (result.length > 0) {
                if (
                  result[0].Value != null &&
                  result[0].Value !== undefined &&
                  result[0].Value !== ''
                ) {
                  /*this.messageService.warning(result[0].Value, {
                    nzDuration: 6000,
                  });*/

                  this.modal.info({
                    nzTitle: result[0].Value,
                    nzOkText: this.layoutService.translate('Ok'),
                    nzOnOk: () => {},
                  });
                }
              }
            });
        }, 1500);
      }
    }
  }

  setDiscountLineToDate(section: RecordCategory, line: number) {
    const qty = section.Lines[line].Properties.find(
      (prop) => prop.Name === 'U_QTY'
    ).ValueAsObject;

    const fromDate = section.Lines[line].Properties.find(
      (prop) => prop.Name === 'U_FROM_DATE'
    ).ValueAsObject;

    let endDate = new Date(fromDate);
    endDate = new Date(endDate.setMonth(endDate.getMonth() + (qty - 1)));
    endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);

    section.Lines[line].Properties.find(
      (prop) => prop.Name === 'U_TO_DATE'
    ).ValueAsObject = endDate;
  }

  calculateLineFromDate(
    section: RecordCategory,
    line: number,
    infoSection: RecordCategory,
    thereIsFirstInvoice: boolean
  ): Date {
    if (line === 0) {
      let year = infoSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'U_ITM_RENT_RECVTOY'
      ).ValueAsObject;

      let month = infoSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'U_ITM_RENT_RECVTOM'
      ).ValueAsObject;

      if (year === null || year === undefined || year === '') {
        year = infoSection.Lines[0].Properties.find(
          // tslint:disable-next-line: no-string-literal
          (prop) => prop.Name === g.SessionValues['U_ITM_SUB_PAIDTOY']
        ).ValueAsObject;

        month = infoSection.Lines[0].Properties.find(
          // tslint:disable-next-line: no-string-literal
          (prop) => prop.Name === g.SessionValues['U_ITM_SUB_PAIDTOM']
        ).ValueAsObject;

        if (year === null || year === undefined || year === '') {
          const baseDate = infoSection.Lines[0].Properties.find(
            // tslint:disable-next-line: no-string-literal
            (prop) => prop.Name === g.SessionValues['U_ITM_SUB_CONTSTART']
          ).ValueAsObject;

          return new Date(baseDate);
        }
      }

      const fromDate = new Date(year, month, 1);
      return fromDate;
    } else {
      if (thereIsFirstInvoice) {
        const year = infoSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'U_ITM_RENT_RECVTOY'
        ).ValueAsObject;

        const month = infoSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'U_ITM_RENT_RECVTOM'
        ).ValueAsObject;

        let fromDate = section.Lines[line - 1].Properties.find(
          (prop) => prop.Name === 'U_TO_DATE'
        ).ValueAsObject;

        fromDate = new Date(fromDate);
        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 1);
        const lastInvoiceDate = new Date(year, month, 1);
        if (fromDate < lastInvoiceDate) {
          fromDate = lastInvoiceDate;
        }
        return fromDate;
      } else {
        let fromDate = section.Lines[line - 1].Properties.find(
          (prop) => prop.Name === 'U_TO_DATE'
        ).ValueAsObject;

        fromDate = new Date(fromDate);
        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 1);
        return fromDate;
      }
    }
  }

  oDocuments(args: FieldValueChangedArgs) {
    // if (args.recordModel.ObjectKey === 'PM_TimeSheetData') {
    //   this.handleTimesheetRecord(args);
    // }
    const lineFieldsUpdateTotal = [
      'Freight1Amount',
      'Freight2Amount',
      'Freight3Amount',
    ];
    const freightVat = ['Freight1VAT', 'Freight2VAT', 'Freight3VAT'];

    const headerFieldsUpdateTotal = ['RoundingDiffAmount'];

    // if (args.recordModel.ModuleId === 100008) {
    if (
      args.recordModel.ModuleId === 10024 ||
      args.recordModel.ObjectKey === 'oInventoryGenExit' ||
      args.recordModel.ObjectKey === 'oInventoryGenEntry'
    ) {
      return;
    }

    // if (args.recordModel.ObjectKey === 'COMPANY_CREATE') {
    //   const section = args.recordModel.Categories.find(
    //     (x) => x.Id === args.sectionTagName
    //   );
    //   if (args.recordProperty.Name === 'CompanyDBName') {
    //     section.Lines.find(l => l.Id === args.line).Properties.find(
    //       (prop) => prop.Name === 'CompanyName'
    //     ).ValueAsObject =
    //       args.recordProperty.ValueAsObject.split(/(?<=[a-z])(?=[A-Z])/).join(
    //         ' '
    //       ) + '****';
    //   }
    // }

    if (args.sectionTagName === 'Contract_Discount_Lines') {
      const section = args.recordModel.Categories.find(
        (x) => x.Id === args.sectionTagName
      );

      const infoSection = args.recordModel.Categories.find(
        (x) => x.Id === 'Documents'
      );

      const thereIsFirstInvoice = infoSection.Lines[0].Properties.find(
        // tslint:disable-next-line: no-string-literal
        (prop) => prop.Name === g.SessionValues['U_ITM_SUB_1ST_INV']
      ).ValueAsObject;

      if (args.recordProperty.Name === 'U_FROM_DATE') {
        this.setDiscountLineToDate(section, args.line);
      }
      if (args.recordProperty.Name === 'U_DISC_NAME') {
        let baseDate = infoSection.Lines[0].Properties.find(
          // tslint:disable-next-line: no-string-literal
          (prop) => prop.Name === g.SessionValues['U_ITM_SUB_CONTSTART']
        ).ValueAsObject;

        if (thereIsFirstInvoice === 'Y' || args.line !== 0) {
          baseDate = this.calculateLineFromDate(
            section,
            args.line,
            infoSection,
            thereIsFirstInvoice === 'Y'
          );
        }
        section.Lines.find((l) => l.Id === args.line).Properties.find(
          (prop) => prop.Name === 'U_FROM_DATE'
        ).ValueAsObject = baseDate;
      }

      if (args.recordProperty.Name === 'U_QTY') {
        this.setDiscountLineToDate(section, args.line);
      }
    } else if (
      args.recordProperty.Name === 'LineTotal' &&
      args.sectionTagName === 'DocumentsAdditionalExpenses'
    ) {
      // this.oDocuments_UpdateTaxSum(args);
      this.oDocuments_TotalCalc(args, false);
    }
    // console.log('FieldValueChangedArgs --> in oDocuments', args);
    if (args.sectionTagName === 'Documents') {
      const section = args.recordModel.Categories.find(
        (x) => x.Id === args.sectionTagName
      );
      let field = section.Lines.find((l) => l.Id === args.line).Properties.find(
        (prop) => prop.Name === args.recordProperty.Name
      );

      if (field != null || field !== undefined) {
        field = args.recordProperty;
      }
      if (args.recordProperty.Name === 'DocDueDate') {
        const documentLinesSection = args.recordModel.Categories.find(
          (x) => x.Id === 'Document_Lines'
        );
        if (
          args.recordModel.ObjectKey === 'oOrders' &&
          this.dueDateShouldNotified &&
          documentLinesSection.Lines.length > 0 &&
          g.customDueDateLogic
        ) {
          this.dueDateShouldNotified = false;
          setTimeout(() => {
            this.modal.confirm({
              nzTitle: this.layoutService.translate(
                'Do you want to copy dispatch date to the lines?'
              ),
              nzOkText: this.layoutService.translate('Yes'),
              nzCancelText: this.layoutService.translate('No'),
              nzOnOk: () => {
                const docDueDate = section.Lines[0].Properties.find(
                  (prop) => prop.Name === 'DocDueDate'
                ).ValueAsObject;
                //console.log(docDueDate);

                documentLinesSection.Lines.forEach((element) => {
                  const treeType = element.Properties.find(
                    (d) => d.Name === 'TreeType'
                  )?.ValueAsObject;

                  const itmLineStatus = element.Properties.find(
                    (d) => d.Name === 'ITM_LineStatus'
                  )?.ValueAsObject;

                  if (
                    treeType !== 'iIngredient' &&
                    treeType !== 'I' &&
                    itmLineStatus !== 'C'
                  ) {
                    const shipDateProp = element.Properties.find(
                      (prop) => prop.Name === 'ShipDate'
                    );

                    LayoutService.setValue(
                      shipDateProp,
                      docDueDate,
                      this.layoutService,
                      args.recordModel,
                      element.Id,
                      'Document_Lines',
                      args.moduleStructure
                    );
                  }
                });
              },
              nzOnCancel: () => {},
            });

            this.dueDateShouldNotified = true;
          }, 2000);
        }
      } else if (args.recordProperty.Name === 'Series') {
        // console.log({ field });
        const seriesVal = section.Lines[0].Properties.find(
          (prop) => prop.Name === 'Series'
        ).ValueAsObject;
        if (seriesVal === '-1') {
          //  readonly false for docnum
        } else {
          //  readonly true for docnum
        }
      } else if (args.recordProperty.Name === 'CardCode') {
        //this.updateRowPricesEvent(args, false, false);

        if (
          g.messageWhenChoosingBPQueryId !== 0 &&
          args.recordModel.ObjectKey === 'oOrders' &&
          args.recordProperty.ValueAsObject != null &&
          args.recordProperty.ValueAsObject !== undefined
        ) {
          setTimeout(() => {
            this.layoutService
              .executeQuery(g.messageWhenChoosingBPQueryId, {
                CardCode: args.recordProperty.ValueAsObject,
              })
              .subscribe((result: any[]) => {
                if (result.length > 0) {
                  if (
                    result[0].Value != null &&
                    result[0].Value !== undefined &&
                    result[0].Value !== ''
                  ) {
                    /*this.messageService.warning(result[0].Value, {
                      nzDuration: 6000,
                    });*/

                    this.modal.info({
                      nzTitle: result[0].Value,
                      nzOkText: this.layoutService.translate('Ok'),
                      nzOnOk: () => {},
                    });
                  }
                }
              });
          }, 1500);
        }

        const lines = args.recordModel.Categories.find(
          (c) => c.Id === 'Document_Lines'
        )?.Lines;
        //const obj = this;
        if (lines != null && lines !== undefined && lines.length > 0) {
          this.modal.confirm({
            nzTitle: this.layoutService.translate(
              "Update document rows according to new BP's data?"
            ),
            nzOkText: this.layoutService.translate('Yes'),
            nzCancelText: this.layoutService.translate('No'),
            nzOnOk: () => {
              lines.forEach((line) => {
                const itemCodeArgs: FieldValueChangedArgs = {
                  line: line.Id,
                  moduleStructure: args.moduleStructure,
                  formId: '',
                  recordModel: args.recordModel,
                  recordProperty: line.Properties.find(
                    (p) => p.Name === 'ItemCode'
                  ),
                  sectionTagName: 'Document_Lines',
                };

                this.updateRowPricesEvent(itemCodeArgs, false, true);
              });
            },
            nzOnCancel: () => {},
          });
        }
      } else if (args.recordProperty.Name === 'DocCurrency') {
        // console.log({ field });
        const docCurrencyVal = section.Lines[0].Properties.find(
          (prop) => prop.Name === 'DocCurrency'
        ).ValueAsObject;
        if (docCurrencyVal === g.companyConfiguration.LocalCurrency) {
          //  hide docRate
        } else {
          //  show docRate
        }
        const docRateVal = section.Lines[0].Properties.find(
          (prop) => prop.Name === 'DocRate'
        ).ValueAsObject;

        const documentLinesSection = args.recordModel.Categories.find(
          (x) => x.Id === 'Document_Lines'
        );
        this.updateRowPricesEvent(args, false, false);
      } else if (args.recordProperty.Name === 'DocRate') {
      } else if (args.recordProperty.Name === 'DocDate') {
        const docDateVal = section.Lines[0].Properties.find(
          (prop) => prop.Name === 'DocDate'
        ).ValueAsObject;
        const taxDateElement = section.Lines[0].Properties.find(
          (prop) => prop.Name === 'TaxDate'
        );
        LayoutService.setValue(
          taxDateElement,
          docDateVal,
          this.layoutService,
          args.recordModel,
          0,
          'Documents',
          args.moduleStructure
        );
      } else if (args.recordProperty.Name === 'TotalDiscount') {
        const totalDiscountVal = section.Lines[0].Properties.find(
          (prop) => prop.Name === 'TotalDiscount'
        ).ValueAsObject;
        let totalDiscount = 0;
        if (totalDiscountVal === undefined || totalDiscountVal === '') {
          totalDiscount = 0;
        } else {
          totalDiscount = Number(totalDiscountVal);
        }

        if (isNaN(totalDiscount)) {
          totalDiscount = 0;
        }

        const totalBeforeDiscountVal = section.Lines[0].Properties.find(
          (prop) => prop.Name === 'TotalBeforeDiscount'
        )?.ValueAsObject;
        let totalBeforeDiscount = 0;
        if (
          totalBeforeDiscountVal === undefined ||
          totalBeforeDiscountVal === ''
        ) {
          totalBeforeDiscount = 0;
        } else {
          totalBeforeDiscount = Number(totalBeforeDiscountVal);
        }

        if (isNaN(totalBeforeDiscount)) {
          totalBeforeDiscount = 0;
        }

        const discountPercElement = section.Lines[0].Properties.find(
          (prop) => prop.Name === 'DiscountPercent'
        );
        let discountPercent = 0;
        if (totalBeforeDiscount === 0) {
          discountPercent = 0;
        } else {
          discountPercent = (totalDiscount / totalBeforeDiscount) * 100;
        }

        LayoutService.setValue(
          discountPercElement,
          discountPercent,
          this.layoutService,
          args.recordModel,
          args.line,
          args.sectionTagName,
          args.moduleStructure
        );
      } else if (args.recordProperty.Name === 'DocType') {
        this.oDocuments_TypeChanged(args);
      } else if (args.recordProperty.Name === 'DiscountPercent') {
        this.DiscountPercentChanged(args);
        this.DocumentChangeDocDiscount(args);
      } else if (
        headerFieldsUpdateTotal.findIndex(
          (x) => x === args.recordProperty.Name
        ) !== -1
      ) {
        // this.Document_UpdateRowTotal(args);
        this.oDocuments_TotalCalc(args, false);
      }
    }

    if (args.sectionTagName === 'Document_Lines') {
      const section = args.recordModel.Categories.find(
        (x) => x.Id === args.sectionTagName
      );
      const field = section.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === args.recordProperty.Name);

      if (field != null && field !== undefined) {
        section.Lines.find((l) => l.Id === args.line).Properties.find(
          (prop) => prop.Name === args.recordProperty.Name
        ).ValueAsObject = args.recordProperty.ValueAsObject;
      }

      if (
        args.recordProperty.Name === 'UnitPrice' ||
        args.recordProperty.Name === 'DiscountPercent'
      ) {
        const discountPercentageObject = section.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'DiscountPercent');
        let discountPercentage = 0;
        if (discountPercentageObject != null) {
          discountPercentage = Number(discountPercentageObject.ValueAsObject);
        }
        // const discountPercentage = Number(
        //   section.Lines.find(l => l.Id === args.line).Properties.find(
        //     (prop) => prop.Name === 'DiscountPercent'
        //   ).ValueAsObject
        // );
        const unitPrice = Number(
          section.Lines.find((l) => l.Id === args.line).Properties.find(
            (prop) => prop.Name === 'UnitPrice'
          ).ValueAsObject
        );
        const priceAfterDiscount =
          unitPrice - (unitPrice * discountPercentage) / 100;
        let priceAfterDiscountEle = section.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'ITM_PriceAftDisc');
        if (
          priceAfterDiscountEle === undefined ||
          priceAfterDiscountEle == null
        ) {
          priceAfterDiscountEle = {
            DataType: FieldDataType.Price,
            Name: 'ITM_PriceAftDisc',
            FieldName: 'ITM_PriceAftDisc',
            // Value: '',
            ValueAsObject: '',
            DBValue: '',
            Disabled: true,
          };

          section.Lines.find((l) => l.Id === args.line).Properties.push(
            priceAfterDiscountEle
          );
        }

        if (
          Number(priceAfterDiscountEle.ValueAsObject) !== priceAfterDiscount
        ) {
          LayoutService.setValue(
            priceAfterDiscountEle,
            priceAfterDiscount,
            this.layoutService,
            args.recordModel,
            args.line,
            args.sectionTagName,
            args.moduleStructure
          );
        }

        if (args.recordProperty.Name === 'DiscountPercent') {
          this.DocumentChangeLineDiscount(args);
        }

        if (args.recordProperty.Name === 'UnitPrice') {
          const itemcode = section.Lines.find(
            (l) => l.Id === args.line
          ).Properties.find((prop) => prop.Name === 'ItemCode');

          const unitPrice = section.Lines.find(
            (l) => l.Id === args.line
          ).Properties.find((prop) => prop.Name === 'UnitPrice');

          if (
            g.updatePricesForSimilarItems &&
            args.sectionTagName === 'Document_Lines' &&
            g.notNotified &&
            itemcode &&
            !unitPrice.FromAutoPrice
          ) {
            const price = unitPrice.ValueAsObject;

            const currency = section.Lines.find(
              (l) => l.Id === args.line
            ).Properties.find((prop) => prop.Name === 'Currency').ValueAsObject;

            let setOfCheckedId = [];
            const itemcode = section.Lines.find(
              (l) => l.Id === args.line
            ).Properties.find((prop) => prop.Name === 'ItemCode').ValueAsObject;

            section.Lines.forEach((element) => {
              if (element.Id !== args.line) {
                let lineItemCodeProp = element.Properties.find(
                  (p) => p.Name === 'ItemCode'
                );
                let lineItemCode = lineItemCodeProp
                  ? lineItemCodeProp.ValueAsObject
                  : null;

                let treeTypeProp = element.Properties.find(
                  (p) => p.Name === 'TreeType'
                );
                let treeType = treeTypeProp ? treeTypeProp.ValueAsObject : null;

                let linePriceProp = element.Properties.find(
                  (p) => p.Name === 'UnitPrice'
                );
                let linePrice = linePriceProp ? linePriceProp.ValueAsObject : 0;

                if (
                  lineItemCode == itemcode &&
                  linePrice != price &&
                  treeType !== 'iIngredient' &&
                  treeType !== 'I'
                ) {
                  setOfCheckedId.push(element.Id);
                }
              }
            });

            if (
              args.recordModel.ObjectKey === 'oOrders' &&
              setOfCheckedId.length > 0 &&
              price !== 0
            ) {
              g.setNotNotified(false);
              this.modal.confirm({
                nzTitle: this.layoutService.translate(
                  'Are you sure you want to copy price to the other line?'
                ),
                nzOkText: this.layoutService.translate('Yes'),
                nzCancelText: this.layoutService.translate('No'),
                nzOnOk: () => {
                  this.DocumentChangeLinePrice(args);
                  section.Lines.forEach((element) => {
                    if (setOfCheckedId.includes(element.Id)) {
                      let linePriceProp = element.Properties.find(
                        (p) => p.Name === 'UnitPrice'
                      );

                      let currencyProp = element.Properties.find(
                        (p) => p.Name === 'Currency'
                      );

                      linePriceProp.ValueAsObject = price;
                      currencyProp.ValueAsObject = currency;
                    }
                  });

                  section.Lines.forEach((element) => {
                    if (setOfCheckedId.includes(element.Id)) {
                      let linePriceProp = element.Properties.find(
                        (p) => p.Name === 'UnitPrice'
                      );
                      let currencyProp = element.Properties.find(
                        (p) => p.Name === 'Currency'
                      );

                      LayoutService.setValue(
                        linePriceProp,
                        price,
                        this.layoutService,
                        args.recordModel,
                        element.Id,
                        args.sectionTagName,
                        args.moduleStructure,
                        true
                      );

                      LayoutService.setValue(
                        currencyProp,
                        currency,
                        this.layoutService,
                        args.recordModel,
                        element.Id,
                        args.sectionTagName,
                        args.moduleStructure,
                        true
                      );
                    }
                  });
                  g.setNotNotified(true);
                },
                nzOnCancel: () => {
                  this.DocumentChangeLinePrice(args);
                  g.setNotNotified(true);
                },
              });
            } else {
              this.DocumentChangeLinePrice(args, args.onload);
            }
          } else {
            unitPrice.FromAutoPrice = false;
            this.DocumentChangeLinePrice(args, args.onload);
          }
        }
      } else if (args.recordProperty.Name === 'Rate') {
        this.DocumentChangeLinePrice(args);
      } else if (
        args.recordProperty.Name === 'Quantity' ||
        args.recordProperty.Name === 'TaxOnly' ||
        (args.recordProperty.Name === 'PriceAfterVAT' &&
          (args.internalTrigger === undefined ||
            (args.internalTrigger !== undefined &&
              args.internalTrigger === false)))
      ) {
        //debugger;
        const priceAfterVatProp = section.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'PriceAfterVAT');
        let priceAfterVat = 0;
        if (priceAfterVatProp != null && priceAfterVatProp !== undefined) {
          priceAfterVat = Number(
            priceAfterVatProp.ValueAsObject === undefined
              ? 0
              : priceAfterVatProp.ValueAsObject
          );
        }

        const quantityObj = section.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'Quantity');
        const quantityVal =
          quantityObj == null ? 0 : Number(quantityObj.ValueAsObject);
        const quantity = quantityVal;
        const grossTotalLc = priceAfterVat * quantity;

        const grossTotalLcEle = section.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'GrossTotalLC');

        LayoutService.setValue(
          grossTotalLcEle,
          grossTotalLc,
          this.layoutService,
          args.recordModel,
          args.line,
          args.sectionTagName,
          args.moduleStructure
        );

        if (args.recordProperty.Name === 'Quantity') {
          this.DocumentChangeLineQuantity(args);
        } else if (args.recordProperty.Name === 'PriceAfterVAT') {
          this.GrossPriceChanged(args, args.onload);
        } else if (args.recordProperty.Name === 'TaxOnly') {
          this.Document_UpdateRowTotal(args);
        }
      } else if (
        args.recordProperty.Name === 'PriceAfterVAT' &&
        args.internalTrigger
      ) {
        //debugger;
        const priceAfterVatProp = section.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'PriceAfterVAT');
        let priceAfterVat = 0;
        if (priceAfterVatProp != null && priceAfterVatProp !== undefined) {
          priceAfterVat = Number(
            priceAfterVatProp.ValueAsObject === undefined
              ? 0
              : priceAfterVatProp.ValueAsObject
          );
        }

        const quantityObj = section.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'Quantity');
        const quantityVal =
          quantityObj == null ? 0 : Number(quantityObj.ValueAsObject);
        const quantity = quantityVal;
        const grossTotalLc = priceAfterVat * quantity;

        const grossTotalLcEle = section.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'GrossTotalLC');

        LayoutService.setValue(
          grossTotalLcEle,
          grossTotalLc,
          this.layoutService,
          args.recordModel,
          args.line,
          args.sectionTagName,
          args.moduleStructure
        );
      }

      // else if (
      //   args.recordProperty.Name === 'OnHand' ||
      //   (g.triggerDeliverScheduleForShipDate &&
      //     args.recordProperty.Name === 'ShipDate' &&
      //     (args.internalTrigger === undefined ||
      //       (args.internalTrigger !== undefined &&
      //         args.internalTrigger === false)))
      // ) {
      //   this.GetDeliveryScheduleSuggestion(args);
      //   if (
      //     g.autoDisplayDeliverSchedule ||
      //     (args.recordProperty.Name === 'ShipDate' &&
      //       g.autoDisplayDeliverScheduleForShipDate) ||
      //     (args.recordProperty.Name === 'OnHand' &&
      //       g.autoDisplayDeliverScheduleForOnHand)
      //   ) {
      //     setTimeout(() => {
      //       this.DisplayDeliverScheduleDrawer(args);
      //     }, 2000);
      //   }
      // }
      else if (
        // args.moduleStructure.module.ObjectTypeValue !== '1470000113' &&
        args.recordProperty.Name === 'ItemCode' ||
        args.recordProperty.Name === 'UoMEntry'
      ) {
        this.updateRowPricesEvent(args, false, true);
      } else if (
        lineFieldsUpdateTotal.findIndex(
          (x) => x === args.recordProperty.Name
        ) !== -1
      ) {
        this.Document_UpdateRowTotal(args);
        // this.oDocuments_TotalCalc(args);
      } else if (
        args.recordProperty.Name === 'TaxCode' ||
        args.recordProperty.Name === 'VatGroup'
      ) {
        this.DocumentChangeLineTax(args);
      } else if (
        freightVat.findIndex((x) => x === args.recordProperty.Name) !== -1 ||
        args.recordProperty.Name === 'LineType'
      ) {
        this.oDocuments_TotalCalc(args, false);
      } else if (args.recordProperty.Name === 'LineTotal') {
        //this.updateDiscount(args);
      }
    }
  }

  DocumentChangeLineDiscount(args: FieldValueChangedArgs) {
    if (args.sectionTagName === 'Documents') {
      return;
    }
    const gp = this.CalculateGrossPrice(args);
    this.SetGrossPrice(args, gp);
    this.Document_UpdateRowTotal(args);
  }

  DocumentChangeLinePrice(
    args: FieldValueChangedArgs,
    onload: boolean = false
  ) {
    if (args.sectionTagName === 'Documents') {
      return;
    }
    const GP = this.CalculateGrossPrice(args, onload);
    this.SetGrossPrice(args, GP);
    this.Document_UpdateRowTotal(args, onload);
    if (
      args.recordModel.ObjectCode === 'Expense_Object' &&
      args.recordProperty.Name === 'UnitPrice'
    ) {
      const documentLinesSection = args.recordModel.Categories.find(
        (x) => x.Id === 'Document_Lines'
      );
      if (documentLinesSection.Lines.length <= 1) {
        return;
      }

      if (documentLinesSection.Lines[0].Id === args.line) {
        return;
      }

      let firstPriceProp = documentLinesSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'UnitPrice'
      );

      let priceProp = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'UnitPrice');

      firstPriceProp.ValueAsObject -= priceProp.ValueAsObject;

      LayoutService.setValue(
        firstPriceProp,
        firstPriceProp.ValueAsObject,
        this.layoutService,
        args.recordModel,
        documentLinesSection.Lines[0].Id,
        args.sectionTagName,
        args.moduleStructure,
        true
      );
    }
  }

  DocumentChangeDocDiscount(args: FieldValueChangedArgs) {
    // this.Document_UpdateRowTotal(args);
    this.oDocuments_TotalCalc(args, false);
  }

  DiscountPercentChanged(args: FieldValueChangedArgs) {
    const section = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const discountPercentage = section.Lines[0].Properties.find(
      (prop) => prop.Name === 'DiscountPercent'
    );
    const discountPercentVal = discountPercentage
      ? discountPercentage.ValueAsObject
      : 0;
    let discountPercent = 0;
    if (discountPercentVal === undefined || discountPercentVal === '') {
      discountPercent = 0;
    } else {
      discountPercent = Number(discountPercentVal);
    }

    if (isNaN(discountPercent)) {
      discountPercent = 0;
    }

    const totalBeforeDiscountVal = section.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalBeforeDiscount'
    )?.ValueAsObject;
    let totalBeforeDiscount = 0;
    if (totalBeforeDiscountVal === undefined || totalBeforeDiscountVal === '') {
      totalBeforeDiscount = 0;
    } else {
      totalBeforeDiscount = Number(totalBeforeDiscountVal);
    }

    const totalDiscountElement = section.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalDiscount'
    );
    const valueToAssign =
      discountPercent === 0 ? 0 : (discountPercent * totalBeforeDiscount) / 100;
    LayoutService.setValue(
      totalDiscountElement,
      valueToAssign,
      this.layoutService,
      args.recordModel,
      0,
      'Documents',
      args.moduleStructure
    );
  }

  CalculateGrossPrice(
    args: FieldValueChangedArgs,
    onload: boolean = false
  ): number {
    const documentsSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );

    const section = args.recordModel.Categories.find(
      (x) => x.Id === args.sectionTagName
    );
    let price = section.Lines.find((l) => l.Id === args.line).Properties.find(
      (prop) => prop.Name === 'UnitPrice'
    ).ValueAsObject;
    if (price === undefined || price == null) {
      price = section.Lines.find((l) => l.Id === args.line).Properties.find(
        (prop) => prop.Name === 'LineTotal'
      ).ValueAsObject;
    }
    const unitprice = Number(price);

    const discountObj = section.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'DiscountPercent');
    let discountValue;
    if (discountObj === undefined || discountObj == null) {
      discountValue = '0';
    } else {
      discountValue = discountObj.ValueAsObject;
    }
    let discount = Number(discountValue);
    if (isNaN(discount)) {
      discount = 0;
    }

    const VatGroupCodeEle = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find(
      (prop) => prop.Name === 'TaxCode' || prop.Name === 'VatGroup'
    );

    let VatGroupCode = '';
    if (VatGroupCodeEle !== undefined) {
      VatGroupCode = VatGroupCodeEle.ValueAsObject;
    }

    const postingDate = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDate'
    ).ValueAsObject;

    const TaxValue = Number(this.GetTaxRate(VatGroupCode, postingDate));

    const docRate = Number(
      args.recordModel.Categories.find(
        (cat) => cat.Id === 'Documents'
      ).Lines[0].Properties.find((prop) => prop.Name === 'DocRate')
        .ValueAsObject
    );
    if (isNaN(docRate)) {
      return 0;
    }

    let ClacGP = 0;
    ClacGP =
      (unitprice / docRate) *
      (((100 - discount) / 100) * ((100 + TaxValue) / 100));

    // inbolsa
    if (Documents.reverseCalculation) {
      ClacGP = unitprice / docRate / (1 - TaxValue / 100);
    }

    return ClacGP;
  }

  SetGrossPrice(args: FieldValueChangedArgs, value: number) {
    const headerRete = Number(
      args.recordModel.Categories.find(
        (cat) => cat.Id === 'Documents'
      ).Lines[0].Properties.find((prop) => prop.Name === 'DocRate')
        .ValueAsObject
    );

    const priceAfterVatEle = args.recordModel.Categories.find(
      (cat) => cat.Id === 'Document_Lines'
    )
      .Lines.find((l) => l.Id === args.line)
      .Properties.find((prop) => prop.Name === 'PriceAfterVAT');

    priceAfterVatEle.ValueAsObject = value;

    this.layoutService.triggerFieldValueChanged({
      recordModel: args.recordModel,
      recordProperty: priceAfterVatEle,
      formId: '',
      line: args.line,
      sectionTagName: args.sectionTagName,
      moduleStructure: args.moduleStructure,
      internalTrigger: true,
    });
    // it makes loop
    /*LayoutService.setValue(
      priceAfterVatEle,
      value,
      this.layoutService,
      args.recordModel,
      args.line,
      args.sectionTagName,
      args.moduleStructure
    );*/
  }

  QtyChanged(args: FieldValueChangedArgs, onload: boolean = false) {
    if (onload) {
      return;
    }

    const documentsSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );

    const cardCodeProp = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'CardCode'
    );

    let cardcode = '';
    if (cardCodeProp != null && cardCodeProp !== undefined) {
      cardcode = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'CardCode'
      ).ValueAsObject;
    }

    const postdate = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDate'
    ).ValueAsObject;
    const delvdate = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDueDate'
    ).ValueAsObject;
    const doccurr = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocCurrency'
    )?.ValueAsObject;

    const itemcode = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'ItemCode').ValueAsObject;
    const qty = Number(
      documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'Quantity').ValueAsObject
    );

    this.UpdateRowPrices(
      args,
      delvdate,
      postdate,
      qty,
      itemcode,
      cardcode,
      doccurr,
      true
    );
  }

  UpdateRowPrices(
    args: FieldValueChangedArgs,
    delvdate: string,
    postdate: string,
    qty: number,
    itemcode: string,
    cardcode: string,
    doccurr: string,
    // tslint:disable-next-line: letiable-name
    quantity_updated: boolean
  ) {
    if (
      itemcode === '' ||
      delvdate === '' ||
      postdate === '' ||
      isNaN(qty) ||
      qty === 0 ||
      doccurr === '' ||
      (cardcode === '' &&
        args.moduleStructure.module.ObjectTypeValue !== '1470000113')
    ) {
      return;
    } else if (
      cardcode === '' &&
      args.moduleStructure.module.ObjectTypeValue === '1470000113' &&
      args.recordProperty.Name === 'ItemCode'
    ) {
      setTimeout(() => {
        /*const vendor = args.recordModel.Categories.find(
          (x) => x.Id === 'Document_Lines'
        )
          .Lines.find((l) => l.Id === args.line)
          .Properties.find((x) => x.Name === 'LineVendor');
        if (
          vendor != null &&
          vendor.ValueAsObject != null &&
          vendor.ValueAsObject != ''
        ) {
          return;
        }*/
        this.layoutService
          .executeQuery(80042, {
            ItemCode: itemcode,
          })
          .subscribe(
            (
              result: { Price: number; Currency: string; Discount: number }[]
            ) => {
              const res = result[0];
              const documentLinesSection = args.recordModel.Categories.find(
                (x) => x.Id === 'Document_Lines'
              );
              //const line = documentLinesSection.Lines[args.line];
              const line = documentLinesSection.Lines.find(
                (l) => l.Id === args.line
              );
              const priceProperty = line.Properties.find(
                (x) => x.Name == 'UnitPrice'
              );
              LayoutService.setValue(
                priceProperty,
                res.Price,
                this.layoutService,
                args.recordModel,
                args.line,
                args.sectionTagName,
                args.moduleStructure
              );
              setTimeout(() => {
                const currencyProperty = line.Properties.find(
                  (x) => x.Name == 'Currency'
                );
                LayoutService.setValue(
                  currencyProperty,
                  res.Currency,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  args.sectionTagName,
                  args.moduleStructure
                );
              }, 100);
              setTimeout(() => {
                const dicountProperty = line.Properties.find(
                  (x) => x.Name == 'DiscountPercent'
                );
                LayoutService.setValue(
                  dicountProperty,
                  res.Discount,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  args.sectionTagName,
                  args.moduleStructure
                );
              }, 100);
            }
          );
      }, 500);
      return;
    }

    /*if ($('[name="object-action"]').val() == 'Details')
      return;*/

    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );

    const linesSection = args.moduleStructure.module.Sections.find(
      (sec) => sec.XmlTagName === 'Document_Lines'
    );
    const unitPrice = linesSection.Fields.find(
      (fie) => fie.PropertyName === 'UnitPrice'
    );
    if (
      unitPrice !== undefined &&
      unitPrice.ParentProperties !== '' &&
      unitPrice.ParentProperties != null
    ) {
      return;
    }

    if (
      g.updatePricesForSimilarItems &&
      args.recordModel.ObjectKey === 'oOrders' &&
      args.sectionTagName === 'Document_Lines' &&
      args.recordProperty.Name === 'ItemCode'
    ) {
      let continueExecute = true;
      const itemcode = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'ItemCode').ValueAsObject;
      const unitPriceProp = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'UnitPrice');
      const currencyProp = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'Currency');
      const discountProp = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'DiscountPercent');

      for (let index = 0; index < documentLinesSection.Lines.length; index++) {
        const line = documentLinesSection.Lines[index];
        const itemcodeInner = line.Properties.find(
          (prop) => prop.Name === 'ItemCode'
        ).ValueAsObject;
        const treeType = line.Properties.find(
          (d) => d.Name === 'TreeType'
        )?.ValueAsObject;

        if (
          line.Id !== args.line &&
          itemcode === itemcodeInner &&
          treeType !== 'iIngredient' &&
          treeType !== 'I'
        ) {
          continueExecute = false;
          const unitPriceInner = line.Properties.find(
            (prop) => prop.Name === 'UnitPrice'
          ).ValueAsObject;
          const discountInner = line.Properties.find(
            (prop) => prop.Name === 'DiscountPercent'
          ).ValueAsObject;
          const currencyInner = line.Properties.find(
            (prop) => prop.Name === 'Currency'
          ).ValueAsObject;

          if (unitPriceProp.ValueAsObject == unitPriceInner) {
            continueExecute = true;
            break;
          }

          this.modal.confirm({
            nzTitle: this.layoutService.translate(
              'Are you sure you want to copy price from the other line?'
            ),
            nzOkText: this.layoutService.translate('Yes'),
            nzCancelText: this.layoutService.translate('No'),
            nzOnOk: () => {
              unitPriceProp.Value = unitPriceInner;
              unitPriceProp.ValueAsObject = unitPriceInner;

              currencyProp.Value = currencyInner;
              currencyProp.ValueAsObject = currencyInner;

              /*LayoutService.setValue(
                unitPriceProp,
                unitPriceInner,
                this.layoutService,
                args.recordModel,
                args.line,
                args.sectionTagName,
                args.moduleStructure,
                true
              );*/

              discountProp.ForceKeepValue = true;
              setTimeout(() => {
                LayoutService.setValue(
                  discountProp,
                  discountInner,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  args.sectionTagName,
                  args.moduleStructure,
                  true
                );
              }, 1000);
            },
            nzOnCancel: () => {
              this.ExecuteNormalUpdateRowPrices(
                documentLinesSection,
                args,
                delvdate,
                postdate,
                qty,
                itemcode,
                cardcode,
                doccurr,
                quantity_updated
              );
            },
          });
          break;
        }
      }
      if (continueExecute) {
        this.ExecuteNormalUpdateRowPrices(
          documentLinesSection,
          args,
          delvdate,
          postdate,
          qty,
          itemcode,
          cardcode,
          doccurr,
          quantity_updated
        );
      }
    } else if (
      (args.recordModel.ObjectKey !== 'oOrders' &&
        args.recordProperty.Name === 'ItemCode') ||
      !g.updatePricesForSimilarItems ||
      (args.recordModel.ObjectKey === 'oOrders' &&
        !g.updatePricesForSimilarItems &&
        args.recordProperty.Name !== 'ItemCode')
    ) {
      this.ExecuteNormalUpdateRowPrices(
        documentLinesSection,
        args,
        delvdate,
        postdate,
        qty,
        itemcode,
        cardcode,
        doccurr,
        quantity_updated
      );
    }
  }

  ExecuteNormalUpdateRowPrices(
    documentLinesSection: RecordCategory,
    args: FieldValueChangedArgs,
    delvdate: string,
    postdate: string,
    qty: number,
    itemcode: string,
    cardcode: string,
    doccurr: string,
    // tslint:disable-next-line: letiable-name
    quantity_updated: boolean
  ) {
    let uomEntry = -1;
    let defaultUOMSqlStatementId = -1;
    const uomEntryElement = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'UoMEntry');

    if (uomEntryElement !== undefined) {
      uomEntry = uomEntryElement.ValueAsObject;
      const lineSection = args.moduleStructure.module.Sections.find(
        (sec) => sec.XmlTagName === 'Document_Lines'
      );
      const uomField = lineSection.Fields.find(
        (fie) => fie.PropertyName === 'UoMEntry'
      );
      defaultUOMSqlStatementId = uomField.SQLStatementParentChanged;
    }

    const params: PriceQueueRequest = new PriceQueueRequest();

    params.Id = Guid.newGuid();
    params.DeliveryDate = this.formatDatetime(
      new Date(delvdate),
      g.companyConfiguration.MomentDateFormat
    );
    params.PostingDate = this.formatDatetime(
      new Date(postdate),
      g.companyConfiguration.MomentDateFormat
    );
    params.Quantity = qty;
    params.ItemCode = itemcode;
    params.CardCode = cardcode;
    params.DocCurr = doccurr;
    params.DefaultUOMSqlStatementId = defaultUOMSqlStatementId;
    params.UomEntry = uomEntry;

    /*const baseEntry = documentLinesSection.Lines[args.line].Properties.find(
      (x) => x.Name === 'BaseEntry'
    )?.ValueAsObject;*/
    const baseEntry = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((x) => x.Name === 'BaseEntry')?.ValueAsObject;

    /*const baseType = documentLinesSection.Lines[args.line].Properties.find(
      (x) => x.Name === 'BaseType'
    )?.ValueAsObject;*/
    const treeType = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((d) => d.Name === 'TreeType')?.ValueAsObject;
    const hideComp = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((x) => x.Name === 'ITM_BOM_BASE_HideComp')?.ValueAsObject;

    if (
      (treeType === 'iIngredient' || treeType === 'I') &&
      (hideComp === 'Y' || g.companyConfiguration.TreePricOn)
    ) {
      return;
    }
    const baseType = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((x) => x.Name === 'BaseType')?.ValueAsObject;

    if (
      (baseEntry != null && baseEntry !== '0') ||
      (baseType != null && baseType !== '-1' && baseType !== -1)
    ) {
      return;
    }

    this.layoutService.getItemPrice(params).subscribe((d: any) => {
      const discount = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'DiscountPercent');

      const price = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'UnitPrice');

      price.FromAutoPrice = true;

      this.UpdateRowPricesQueueProcessor(args, quantity_updated, d[0].Response);

      price.IgnoreAutoPrice = false;
      discount.IgnoreAutoPrice = false;

      this.oDocuments_TotalCalc(args, false);
    });
  }

  UpdateRowPricesQueueProcessor(
    args: FieldValueChangedArgs,
    quantityUpdated: boolean,
    result: any
  ) {
    const updatePriceOnUpdateQty = true; //  should be a global letiable
    let setDefaultDiscount = g.setDefaultDiscount ? 'Y' : 'N'; //  should be a global letiable.
    let setDefaultDiscountOnQtyChange = g.setDefaultDiscountOnQtyChange;

    if (result.Has_Error) {
      this.messageService.create('error', result.Error_Message);
    } else {
      const documentsSection = args.recordModel.Categories.find(
        (x) => x.Id === 'Documents'
      );
      const documentLinesSection = args.recordModel.Categories.find(
        (x) => x.Id === 'Document_Lines'
      );
      const postingDate = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'DocDate'
      )?.ValueAsObject;

      const docCurrency = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'DocCurrency'
      ).ValueAsObject;

      const price = result.Resault_Value.Price;
      const discount = result.Resault_Value.Discount;
      const purtax = result.Resault_Value.PurchasingTaxCode;
      const saletax = result.Resault_Value.SalesTaxCode;
      const IsGrossPrice = result.Resault_Value.IsGrossPrice;
      let currency = result.Resault_Value.Currency;
      if (currency == null || currency == '') {
        currency = docCurrency;
      }

      /*$('input, select, textarea', row).each(function () {
        $(this).attr('inner-event', 'true');
      });*/
      const itemsSection = args.moduleStructure.module.Sections.find(
        (x) => x.AdditionalIdentifier === 'items'
      );
      const discountParent = itemsSection.Fields.find(
        (x) => x.PropertyName === 'DiscountPercent'
      ).ParentProperties;
      if (discountParent == null || discountParent === '') {
        setDefaultDiscount = 'Y';
        setDefaultDiscountOnQtyChange = true;
      }

      if (setDefaultDiscount === 'Y') {
        if (quantityUpdated) {
          if (setDefaultDiscountOnQtyChange) {
            const fieldToUpdate = documentLinesSection.Lines.find(
              (l) => l.Id === args.line
            ).Properties.find((prop) => prop.Name === 'DiscountPercent');
            // const current_disc = this.getNumberValue(fieldToUpdate.ValueAsObject);

            LayoutService.setValue(
              fieldToUpdate,
              discount,
              this.layoutService,
              args.recordModel,
              args.line,
              'Document_Lines',
              args.moduleStructure
            );
          }

          // $(document).trigger('DiscountPercentChanged', [{ Field: $(row).find('[name="Document_Lines.DiscountPercent"]') }]);
        } else {
          const fieldToUpdate = documentLinesSection.Lines.find(
            (l) => l.Id === args.line
          ).Properties.find((prop) => prop.Name === 'DiscountPercent');
          const currentDisc = this.getNumberValue(fieldToUpdate.ValueAsObject);

          LayoutService.setValue(
            fieldToUpdate,
            discount,
            this.layoutService,
            args.recordModel,
            args.line,
            'Document_Lines',
            args.moduleStructure
          );
        }
      }

      // tslint:disable-next-line: max-line-length
      // let VatGroupCode = documentLinesSection.Lines.find(l => l.Id === args.line).Properties.find(prop => prop.Name == "TaxCode" || prop.Name == "VatGroup").Value;
      const vatGroupCodeElement = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find(
        (prop) => prop.Name === 'TaxCode' || prop.Name === 'VatGroup'
      );
      const sectionStructure = args.moduleStructure.module.Sections.find(
        (section) => section.XmlTagName === 'Document_Lines'
      );
      const fieldStructure = sectionStructure.Fields.find(
        (f) => f.PropertyName === 'TaxCode' || f.PropertyName === 'VatGroup'
      );

      if (fieldStructure !== undefined) {
        this.getOptions(
          fieldStructure,
          'Document_Lines',
          documentLinesSection,
          args.line,
          vatGroupCodeElement,
          args.recordModel
        );

        if (
          args.moduleStructure.module.AdditionalInformationParsed
            .InventoryDirection === ModuleInventoryDirection.Inbound ||
          args.moduleStructure.module.ObjectType.indexOf('Purchase') !== -1
        ) {
          if (purtax != null && purtax !== '') {
            LayoutService.setValue(
              vatGroupCodeElement,
              purtax,
              this.layoutService,
              args.recordModel,
              args.line,
              args.sectionTagName,
              args.moduleStructure
            );
          }
        } else {
          if (
            saletax !== '' &&
            fieldStructure.SQLStatementParentChanged == null
          ) {
            LayoutService.setValue(
              vatGroupCodeElement,
              saletax,
              this.layoutService,
              args.recordModel,
              args.line,
              args.sectionTagName,
              args.moduleStructure
            );
          }
        }
      }

      const HideComp = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find(
        (x) => x.Name === 'ITM_BOM_BASE_HideComp'
      )?.ValueAsObject;
      const baseItemCode = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).BaseItemCodeProp;
      const treeType = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((x) => x.Name === 'TreeType')?.ValueAsObject;
      if (quantityUpdated) {
        const baseEntryElement = documentLinesSection.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'BaseEntry');
        let baseEntry = '0';
        if (baseEntryElement === undefined) {
          baseEntry = '0';
        }

        const currentPrice = this.getNumberValue(
          documentLinesSection.Lines.find(
            (l) => l.Id === args.line
          ).Properties.find((prop) => prop.Name === 'UnitPrice').ValueAsObject
        );
        if (IsGrossPrice) {
          const VatGroupCode = documentLinesSection.Lines.find(
            (l) => l.Id === args.line
          ).Properties.find(
            (prop) => prop.Name === 'TaxCode' || prop.Name === 'VatGroup'
          ).ValueAsObject;

          const rate = Number(this.GetTaxRate(VatGroupCode, postingDate));
          const finalPrice = (100 * price) / (100 + rate);

          // let result = final_price;
          if (
            updatePriceOnUpdateQty &&
            finalPrice < currentPrice &&
            baseEntry === '0' &&
            finalPrice !== 0
          ) {
            const fieldToUpdate = documentLinesSection.Lines.find(
              (l) => l.Id === args.line
            ).Properties.find((prop) => prop.Name === 'UnitPrice');
            if (HideComp === 'N') {
              if (
                baseItemCode.ValueAsObject === '' &&
                (treeType === 'S' || treeType === 'iSalesTree')
              ) {
                fieldToUpdate.ReadOnly = true;
                LayoutService.setValue(
                  fieldToUpdate,
                  0,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              } else if (baseItemCode.ValueAsObject !== '') {
                LayoutService.setValue(
                  fieldToUpdate,
                  finalPrice,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              }
            } else if (
              HideComp === 'Y' /*&&
              treeType !== 'N' &&
              treeType !== 'iNotATree'*/
            ) {
              if (baseItemCode.ValueAsObject === '') {
                LayoutService.setValue(
                  fieldToUpdate,
                  finalPrice,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              } else if (
                baseItemCode.ValueAsObject !== '' &&
                (treeType === 'I' || treeType === 'iIngrediant')
              ) {
                fieldToUpdate.ReadOnly = true;
                LayoutService.setValue(
                  fieldToUpdate,
                  0,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              }
            } else {
              LayoutService.setValue(
                fieldToUpdate,
                finalPrice,
                this.layoutService,
                args.recordModel,
                args.line,
                'Document_Lines',
                args.moduleStructure
              );
            }

            // to be discuss // $(document).trigger('PriceChanged', [{ Field: fieldToUpdate }]);
            // UpdatePriceAfterDiscount(fieldToUpdate);
            // ValueChanged(fieldToUpdate, null, row, false);
          }
        } else {
          // let resultPrice = price;
          if (
            updatePriceOnUpdateQty &&
            price < currentPrice &&
            baseEntry === '0' &&
            price !== 0
          ) {
            const fieldToUpdate = documentLinesSection.Lines.find(
              (l) => l.Id === args.line
            ).Properties.find((prop) => prop.Name === 'UnitPrice');
            if (HideComp === 'N') {
              if (
                baseItemCode.ValueAsObject === '' &&
                (treeType === 'S' || treeType === 'iSalesTree')
              ) {
                fieldToUpdate.ReadOnly = true;
                LayoutService.setValue(
                  fieldToUpdate,
                  0,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              } else if (baseItemCode.ValueAsObject !== '') {
                LayoutService.setValue(
                  fieldToUpdate,
                  price,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              }
            } else if (
              HideComp === 'Y' /*&&
              treeType !== 'N' &&
              treeType !== 'iNotATree'*/
            ) {
              if (baseItemCode.ValueAsObject === '') {
                LayoutService.setValue(
                  fieldToUpdate,
                  price,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              } else if (
                baseItemCode.ValueAsObject !== '' &&
                (treeType === 'I' || treeType === 'iIngredient')
              ) {
                fieldToUpdate.ReadOnly = true;
                LayoutService.setValue(
                  fieldToUpdate,
                  0,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              }
            } else {
              LayoutService.setValue(
                fieldToUpdate,
                price,
                this.layoutService,
                args.recordModel,
                args.line,
                'Document_Lines',
                args.moduleStructure
              );
            }
            // to be discuss // $(document).trigger('PriceChanged', [{ Field: fieldToUpdate }]);
            // UpdatePriceAfterDiscount(fieldToUpdate);
            // ValueChanged(fieldToUpdate, null, row, false);
          }
        }

        if (
          currency !== '' &&
          currency !== undefined &&
          updatePriceOnUpdateQty
        ) {
          const currencyControl = documentLinesSection.Lines.find(
            (l) => l.Id === args.line
          ).Properties.find((prop) => prop.Name === 'Currency');

          LayoutService.setValue(
            currencyControl,
            currency,
            this.layoutService,
            args.recordModel,
            args.line,
            'Document_Lines',
            args.moduleStructure
          );
        }
      } else {
        if (
          parseFloat(price) !== 0 ||
          args.recordProperty.Name === 'ItemCode' ||
          args.recordProperty.Name === 'UoMEntry'
        ) {
          if (IsGrossPrice) {
            const VatGroupCode = documentLinesSection.Lines.find(
              (l) => l.Id === args.line
            ).Properties.find(
              (prop) => prop.Name === 'TaxCode' || prop.Name === 'VatGroup'
            ).ValueAsObject;
            const rate = Number(this.GetTaxRate(VatGroupCode, postingDate));
            const finalPrice = (100 * price) / (100 + rate);

            const fieldToUpdate = documentLinesSection.Lines.find(
              (l) => l.Id === args.line
            ).Properties.find((prop) => prop.Name === 'UnitPrice');
            if (HideComp === 'N') {
              if (
                baseItemCode.ValueAsObject === '' &&
                (treeType === 'S' || treeType === 'iSalesTree')
              ) {
                fieldToUpdate.ReadOnly = true;
                LayoutService.setValue(
                  fieldToUpdate,
                  0,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              } else if (baseItemCode.ValueAsObject !== '') {
                LayoutService.setValue(
                  fieldToUpdate,
                  finalPrice,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              }
            } else if (
              HideComp === 'Y' /*&&
              treeType !== 'N' &&
              treeType !== 'iNotATree'*/
            ) {
              if (baseItemCode.ValueAsObject === '') {
                LayoutService.setValue(
                  fieldToUpdate,
                  finalPrice,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              } else if (
                baseItemCode.ValueAsObject !== '' &&
                (treeType === 'I' || treeType === 'iIngrediant')
              ) {
                fieldToUpdate.ReadOnly = true;
                LayoutService.setValue(
                  fieldToUpdate,
                  0,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              }
            } else {
              LayoutService.setValue(
                fieldToUpdate,
                finalPrice,
                this.layoutService,
                args.recordModel,
                args.line,
                'Document_Lines',
                args.moduleStructure
              );
            }
            //  to be discuss// $(document).trigger('PriceChanged', [{ Field: fieldToUpdate }]);
            // UpdatePriceAfterDiscount(fieldToUpdate);
            // ValueChanged(fieldToUpdate, null, row, false);
          } else {
            const fieldToUpdate = documentLinesSection.Lines.find(
              (l) => l.Id === args.line
            ).Properties.find((prop) => prop.Name === 'UnitPrice');
            if (HideComp === 'N') {
              if (
                baseItemCode.ValueAsObject === '' &&
                (treeType === 'S' || treeType === 'iSalesTree')
              ) {
                fieldToUpdate.ReadOnly = true;
                LayoutService.setValue(
                  fieldToUpdate,
                  0,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              } else if (baseItemCode.ValueAsObject !== '') {
                LayoutService.setValue(
                  fieldToUpdate,
                  price,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              }
            } else if (
              HideComp === 'Y' /*&&
              treeType !== 'N' &&
              treeType !== 'iNotATree'*/
            ) {
              if (baseItemCode.ValueAsObject === '') {
                LayoutService.setValue(
                  fieldToUpdate,
                  price,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              } else if (
                baseItemCode.ValueAsObject !== '' &&
                (treeType === 'I' || treeType === 'iIngrediant')
              ) {
                fieldToUpdate.ReadOnly = true;
                LayoutService.setValue(
                  fieldToUpdate,
                  0,
                  this.layoutService,
                  args.recordModel,
                  args.line,
                  'Document_Lines',
                  args.moduleStructure
                );
              }
            } else {
              LayoutService.setValue(
                fieldToUpdate,
                price,
                this.layoutService,
                args.recordModel,
                args.line,
                'Document_Lines',
                args.moduleStructure
              );
            }
            //  to be discuss// $(document).trigger('PriceChanged', [{ Field: fieldToUpdate }]);
            // UpdatePriceAfterDiscount(fieldToUpdate);
            // ValueChanged(fieldToUpdate, null, row, false);
          }
        }

        if (currency !== '' && currency !== undefined) {
          const currencyControl = documentLinesSection.Lines.find(
            (l) => l.Id === args.line
          ).Properties.find((prop) => prop.Name === 'Currency');
          if (currencyControl !== undefined) {
            LayoutService.setValue(
              currencyControl,
              currency,
              this.layoutService,
              args.recordModel,
              args.line,
              'Document_Lines',
              args.moduleStructure
            );
          }
        }
      }

      /*$('input, select, textarea', row).each(function () {
        $(this).attr('inner-event', 'false');
      });*/

      this.DocumentChangeLineTax(args, false);
      /*$taxProperty = $(row).find(TaxPropertyName);
      // console.log('$taxProperty', $taxProperty);
      DocumentChangeLineTax($taxProperty, false);*/
    }
  }

  updateRowPricesEvent(
    args: FieldValueChangedArgs,
    onload: boolean,
    isItem: boolean
  ) {
    if (
      args.recordModel.ObjectKey === 'oInventoryGenExit' ||
      args.recordModel.ObjectKey === 'oInventoryGenEntry'
    ) {
      return;
    }
    if (onload) {
      return;
    }

    const documentsSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    let cardCode;
    if (args.moduleStructure.module.ObjectTypeValue === '1470000113') {
      const cardCodeEle = args.recordModel.Categories.find(
        (x) => x.Id === 'Document_Lines'
      )
        .Lines.find((l) => l.Id === args.line)
        ?.Properties.find((x) => x.Name === 'LineVendor')?.ValueAsObject;
      cardCode = cardCodeEle ?? '';
    } else {
      const cardCodeEle = documentsSection.Lines[0]?.Properties.find(
        (prop) => prop.Name === 'CardCode'
      )?.ValueAsObject;
      cardCode = cardCodeEle ?? '';
    }
    // const cardcode = cardCodeEle.ValueAsObject;

    const postdateEle = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDate'
    );
    const postdate = postdateEle.ValueAsObject;

    const delvdateEle = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDueDate'
    );
    const delvdate = postdateEle.ValueAsObject;

    const doccurrEle = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocCurrency'
    );
    const doccurr = doccurrEle?.ValueAsObject;

    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );
    if (documentLinesSection.Lines.length !== 0) {
      const itemcode = documentLinesSection.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'ItemCode').ValueAsObject;
      let qty = Number(
        documentLinesSection.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'Quantity').ValueAsObject
      );

      if (qty === 0) {
        documentLinesSection.Lines.find(
          (l) => l.Id === args.line
        ).Properties.find((prop) => prop.Name === 'Quantity').ValueAsObject = 1;

        qty = 1;
      }

      let timeout = 0;
      const getPriceInterval = setInterval(() => {
        if (LayoutService.parentChangedQueue.length > 0 && timeout < 10) {
          timeout++;
          return;
        }

        this.UpdateRowPrices(
          args,
          delvdate,
          postdate,
          qty,
          itemcode,
          cardCode,
          doccurr,
          false
        );

        clearInterval(getPriceInterval);
      }, 200);
    }

    if (isItem) {
      this.Document_UpdateRowTotal(args);
    }
  }

  Document_UpdateRowTotal(args: FieldValueChangedArgs, onload = false) {
    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );
    const docType = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    ).Lines[0].Properties.find((z) => z.Name === 'DocType').ValueAsObject;
    const setDocumentLineTotal = true; //  should be a global letiable
    const section = args.recordModel.Categories.find(
      (x) => x.Id === args.sectionTagName
    );

    let quantity = 1.0;

    let quantityElement = section.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'Quantity');
    if (quantityElement === undefined) {
      if (documentLinesSection.Lines[0] === undefined) {
        return;
      }
      quantityElement = documentLinesSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'Quantity'
      );
    }
    const quantityStr =
      quantityElement != null ? quantityElement.ValueAsObject : null;
    if (
      quantityStr === '' ||
      quantityStr == null ||
      docType === 'S' ||
      docType === 'dDocument_Service'
    ) {
      quantity = 1.0;
    } else {
      quantity = Number(quantityStr);
    }

    let discountValue = section.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'DiscountPercent')?.ValueAsObject;

    if (discountValue === null || discountValue === undefined) {
      discountValue = '0';
    }
    let discount = Number(discountValue);

    if (discount == null || isNaN(discount)) {
      discount = 0;
    }
    const exchangeRateProp = section.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((x) => x.Name === 'Rate');

    const docRateProp = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    ).Lines[0].Properties.find((prop) => prop.Name === 'DocRate');
    // const exchangeRateText = this.GetLinesExchangeRate();
    // const exchangeRate = Number(exchangeRateText);
    let exchangeRate;
    if (exchangeRateProp === undefined || exchangeRateProp == null) {
      exchangeRate = 1;
    } else {
      exchangeRate = section.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((x) => x.Name === 'Rate').ValueAsObject;
    }
    if (exchangeRate === '') {
      exchangeRate = 1;
    }
    if (exchangeRate === docRateProp.ValueAsObject || exchangeRate <= 0) {
      exchangeRate = 1;
    }
    let unitprice = section.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'UnitPrice').ValueAsObject;
    if (unitprice === undefined || unitprice == null) {
      unitprice = section.Lines.find((l) => l.Id === args.line).Properties.find(
        (prop) => prop.Name === 'LineTotal'
      ).ValueAsObject;
    }
    const price = Number(unitprice) / exchangeRate;

    const afterdiscount =
      quantity * price - (quantity * price * discount) / 100;

    if (setDocumentLineTotal) {
      LayoutService.setValue(
        section.Lines.find((l) => l.Id === args.line).Properties.find(
          (prop) => prop.Name === 'LineTotal'
        ),
        afterdiscount,
        this.layoutService,
        args.recordModel,
        args.line,
        args.sectionTagName,
        args.moduleStructure
      );
    }

    this.oDocuments_TotalCalc(args, onload);
    /*let Object = $('[name="current_object"]').val();
    if (Object == 'oPurchaseDownPayments' || Object == 'oDownPayments') {
        DownPaymentAmountChanged(sender, onload);
    }*/
  }

  GetLinesExchangeRate(): string {
    return '0.5';
  }

  oDocuments_TotalCalc(args: FieldValueChangedArgs, onLoad: boolean) {
    let totalFreight = 0.0;

    if (
      args.recordModel.ObjectKey === 'oInventoryGenExit' ||
      args.recordModel.ObjectKey === 'oInventoryGenEntry'
    ) {
      return;
    }
    const documentsSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );

    this.oDocuments_UpdateTaxSum(args, onLoad);
    // get the freight amount from header not lines - added by james
    const documentsAdditionalExpenses = args.recordModel.Categories.find(
      (x) => x.Id === 'DocumentsAdditionalExpenses'
    );

    if (documentsAdditionalExpenses != null) {
      documentsAdditionalExpenses.Lines.forEach((element) => {
        const lineFrightObj = element.Properties.find(
          (x) => x.Name === 'LineTotal'
        );
        const lineFreightAmount =
          lineFrightObj != null ? lineFrightObj.ValueAsObject : 0;
        totalFreight += lineFreightAmount;
      });
    }

    const totals = Number(
      this.oDocuments_GetTotals(args.recordModel, args.moduleStructure)
    );
    let discountStr = '0';
    let discount = 0;
    const discountProp = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalDiscount'
    );
    discountStr = discountProp ? discountProp.ValueAsObject : '0';
    const discountOercProp = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DiscountPercent'
    );
    const discountPercStr = discountOercProp
      ? discountOercProp.ValueAsObject
      : '0';
    let discountPerc = Number(discountPercStr);
    if (isNaN(discountPerc)) {
      discountPerc = 0;
    }

    if (discountStr == null || discountStr === undefined) {
      discountStr = '0';
    } else {
      discount = totals * (discountPerc / 100);
    }

    if (discount == null || discount === undefined || isNaN(discount)) {
      discount = 0;
    }

    // discount = oDocuments_Object.ParseUnitPrice(discount.replace('%', '')).itmToNumber();
    if (isNaN(discount)) {
      discount = totals * (discountPerc / 100);
    }

    const downAmount = 0;

    let total = 0;
    if (downAmount == null || downAmount === undefined) {
      total = totals - discount - downAmount;
    } else {
      total = totals - discount;
    }

    /*$('[name="DocumentsAdditionalExpenses.LineTotal"]', $form).each(function () {
        totalFreight = totalFreight + oDocuments_Object.ParseUnitPrice($(this).val());
    });*/
    const postingDate = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDate'
    )?.ValueAsObject;
    const totalFreightLines = 0.0;
    totalFreight += this.GetTotalFreight(
      documentLinesSection,
      postingDate
    ).totalFreightAmount;
    // documentLinesSection.Lines.forEach((element) => {
    //   const freightAmount1 = 0; // oDocuments_Object.ParseUnitPrice($('[name="Document_Lines.Freight1Amount"]', row).val());
    //   const freightAmount2 = 0; // oDocuments_Object.ParseUnitPrice($('[name="Document_Lines.Freight2Amount"]', row).val());
    //   const freightAmount3 = 0; // oDocuments_Object.ParseUnitPrice($('[name="Document_Lines.Freight3Amount"]', row).val());

    //   totalFreightLines = totalFreightLines + freightAmount1;
    //   totalFreightLines = totalFreightLines + freightAmount2;
    //   totalFreightLines = totalFreightLines + freightAmount3;

    //   totalFreight = totalFreight + freightAmount1;
    //   totalFreight = totalFreight + freightAmount2;
    //   totalFreight = totalFreight + freightAmount3;
    // });

    let roundingStr = 0;
    const roundingElem = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'RoundingDiffAmount'
    );

    if (roundingElem !== undefined) {
      roundingStr = roundingElem.ValueAsObject;
    }

    let rounding = Number(roundingStr);
    if (isNaN(rounding)) {
      rounding = 0;
    }

    const DownPaymentAmount = 0; //  oDocuments_Object.ParseUnitPrice($('[name="Documents.ITM_DPM_AMOUNT"]', $form).val()).itmToNumber();
    //  console.log({'DownPaymentAmount': DownPaymentAmount});

    // documentsSection.Lines[0].Properties.find(prop => prop.Name == "TotalFrieght").Value = totalFreight.toString();

    let grossTotal = this.oDocuments_GetTotalsGross(args);
    if (downAmount == null || downAmount === undefined) {
      grossTotal = grossTotal - discount - downAmount;
    } else {
      grossTotal = grossTotal - discount;
    }

    LayoutService.setValue(
      documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'DocTotal'
      ),
      grossTotal + rounding + totalFreight - DownPaymentAmount,
      this.layoutService,
      args.recordModel,
      0,
      'Documents',
      args.moduleStructure
    ); // .change()

    this.DiscountPercentChanged(args);
  }

  DocumentChangeLineQuantity(args: FieldValueChangedArgs) {
    this.QtyChanged(args);
    this.Document_UpdateRowTotal(args);

    // this.GetDeliveryScheduleSuggestion(args);
    // if (
    //   g.autoDisplayDeliverSchedule ||
    //   g.autoDisplayDeliverScheduleForQuantity
    // ) {
    //   setTimeout(() => {
    //     this.DisplayDeliverScheduleDrawer(args);
    //   }, 2000);
    // }
  }

  deliverScheduledIsOpened: boolean[] = [];

  // DisplayDeliverScheduleDrawer(
  //   args: FieldValueChangedArgs,
  //   ignoreCondition: boolean = false
  // ) {
  //   const documents = this;
  //   /*let recordLine = args.recordModel.Categories.find(
  //     (c) => c.Id === 'Document_Lines'
  //   ).Lines.find(
  //     (l) =>
  //       l.Properties.find((p) => p.Name === 'LineNum').ValueAsObject ===
  //       args.line
  //   );
  //   if (recordLine === undefined) {
  //     recordLine = args.recordModel.Categories.find(
  //       (c) => c.Id === 'Document_Lines'
  //     ).Lines.find((l) => l.Id === args.line);
  //   }*/
  //   let recordLine = args.recordModel.Categories.find(
  //     (c) => c.Id === 'Document_Lines'
  //   ).Lines.find((l) => l.Id === args.line);

  //   let itemCode = recordLine.Properties.find(
  //     (p) => p.Name === 'ItemCode'
  //   ).ValueAsObject;

  //   console.log(documents.deliverScheduledIsOpened);

  //   if (documents.deliverScheduledIsOpened[itemCode]) {
  //     return;
  //   }

  //   if (recordLine == null || recordLine === undefined) {
  //     return;
  //   }

  //   let treeTypeProp = recordLine.Properties.find((p) => p.Name === 'TreeType');
  //   let treeType = treeTypeProp ? treeTypeProp.ValueAsObject : null;

  //   const qty = Number(
  //     recordLine.Properties.find((prop) => prop.Name === 'Quantity')
  //       .ValueAsObject
  //   );
  //   const onHand = Number(
  //     recordLine.Properties.find((prop) => prop.Name === 'OnHand').ValueAsObject
  //   );

  //   if (
  //     !ignoreCondition &&
  //     (args.recordProperty.Name === 'Quantity' ||
  //       args.recordProperty.Name === 'OnHand') &&
  //     (qty <= onHand || treeType === 'I' || treeType === 'iIngredient')
  //   ) {
  //     return;
  //   }

  //   let scheduleSuggestionsStr = recordLine.Properties.find(
  //     (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE'
  //   ).ValueAsObject;

  //   let scheduleSuggestions: any;
  //   try {
  //     scheduleSuggestions = JSON.parse(scheduleSuggestionsStr);
  //   } catch {
  //     scheduleSuggestions = {};
  //   }

  //   const lineShipDate = recordLine.Properties.find(
  //     (p) => p.Name === 'ShipDate'
  //   ).ValueAsObject;

  //   let shipDateFromDeliverSchedule = new Date();

  //   try {
  //     scheduleSuggestions.forEach(function (schedule) {
  //       var scheduleDate = schedule.DeliveryDate;
  //       shipDateFromDeliverSchedule = scheduleDate;
  //       return;
  //     });
  //   } catch {
  //     return;
  //   }

  //   if (
  //     !ignoreCondition &&
  //     args.recordProperty.Name === 'ShipDate' &&
  //     (lineShipDate == shipDateFromDeliverSchedule ||
  //       treeType === 'I' ||
  //       treeType === 'iIngredient')
  //   ) {
  //     return;
  //   }

  //   if (scheduleSuggestions.length < 2) {
  //     return;
  //   }

  //   const drawerRef = this.layoutService.drawerService.create({
  //     nzContent: ScheduleSuggestionsComponent,
  //     nzWrapClassName: 'drawer-size-3x',
  //     nzContentParams: {
  //       scheduleSuggestions: scheduleSuggestions,
  //       recordLine: recordLine,
  //       recordModel: args.recordModel,
  //       line: args.line,
  //     },
  //     nzTitle: 'Delivery Schedule',
  //   });
  //   documents.deliverScheduledIsOpened[itemCode] = true;

  //   drawerRef.afterOpen.subscribe(() => {
  //     const instance = drawerRef.getContentComponent();
  //     if (instance && instance.okButtonClicked) {
  //       instance.okButtonClicked.subscribe(() => {
  //         const instance1 = drawerRef.getContentComponent();
  //         console.log('Filter button clicked:', instance1.scheduleSuggestions);

  //         recordLine.Properties.find(
  //           (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE'
  //         ).ValueAsObject = JSON.stringify(instance1.scheduleSuggestions);

  //         const lineShipDate = recordLine.Properties.find(
  //           (p) => p.Name === 'ShipDate'
  //         );
  //         if (lineShipDate != null && lineShipDate !== undefined) {
  //           this.layoutService.triggerFieldValueChanged({
  //             recordModel: args.recordModel,
  //             recordProperty: lineShipDate,
  //             formId: '',
  //             line: args.line,
  //             sectionTagName: args.sectionTagName,
  //             moduleStructure: args.moduleStructure,
  //             internalTrigger: true,
  //           });
  //         }

  //         drawerRef.close();
  //         documents.deliverScheduledIsOpened[itemCode] = false;

  //         this.layoutService.submitDeliverSchedule.emit(args.line);
  //       });
  //     }
  //     if (instance && instance.cancelButtonClicked) {
  //       instance.cancelButtonClicked.subscribe(() => {
  //         documents.deliverScheduledIsOpened[itemCode] = false;
  //         drawerRef.close();
  //       });
  //     }
  //   });
  // }

  // GetDeliveryScheduleSuggestion(e: FieldValueChangedArgs) {
  //   const documents = this;
  //   let recordModel = e.recordModel;
  //   let recordProperty = e.recordProperty;

  //   //console.log('recordProperty.Name>>',recordProperty.Name);

  //   let lineCat = recordModel.Categories.find((x) => x.Id === 'Document_Lines');
  //   let headerCat = recordModel.Categories.find((x) => x.Id === 'Documents');

  //   let recordLineOfField = lineCat.Lines.find((l) => l.Id === e.line);

  //   let docEntryProp = lineCat.Lines[0].Properties.find(
  //     (p) => p.Name === 'DocEntry'
  //   );

  //   let lineNumProp = recordLineOfField.Properties.find(
  //     (p) => p.Name === 'LineNum'
  //   );

  //   let itemCodeProp = recordLineOfField.Properties.find(
  //     (p) => p.Name === 'ItemCode'
  //   );
  //   let itemCode = itemCodeProp ? itemCodeProp.ValueAsObject : null;
  //   if (itemCode == null || itemCode === undefined || itemCode === '') {
  //     return;
  //   }

  //   // Get Quantity from the current line
  //   let quantityProp = recordLineOfField.Properties.find(
  //     (p) => p.Name === 'Quantity'
  //   );
  //   let quantity = quantityProp ? quantityProp.ValueAsObject : 0;

  //   // Get the UDF for delivery schedule
  //   let deliverProp = recordLineOfField.Properties.find(
  //     (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE'
  //   );

  //   let treeTypeProp = recordLineOfField.Properties.find(
  //     (p) => p.Name === 'TreeType'
  //   );
  //   let treeType = treeTypeProp ? treeTypeProp.ValueAsObject : null;

  //   let InvntItemProp = recordLineOfField.Properties.find(
  //     (p) => p.Name === 'InvntItem'
  //   );
  //   let InvntItem = InvntItemProp ? InvntItemProp.ValueAsObject : null;

  //   //debugger;
  //   // Get Requested Delivery Date from the current line
  //   let shipDateProp = recordLineOfField.Properties.find(
  //     (p) => p.Name === 'ShipDate' || p.Name === 'DeliveryDate'
  //   );

  //   /*let shipDatePropHeader = recordLineOfField.Properties.find(
  //     (p) => p.Name === 'ShipDate' || p.Name === 'DeliveryDate'
  //   );*/

  //   let headerDueDate = headerCat.Lines[0].Properties.find(
  //     (p) => p.Name === 'DocDueDate'
  //   ).ValueAsObject;

  //   let requestedDeliveryDate = shipDateProp
  //     ? shipDateProp.ValueAsObject
  //     : null;
  //   if (requestedDeliveryDate == '' || undefined) {
  //     requestedDeliveryDate = headerDueDate;
  //   }

  //   if (
  //     recordProperty.Name === 'Quantity' &&
  //     new Date(headerDueDate) < new Date()
  //   ) {
  //     requestedDeliveryDate = new Date();
  //   } else if (
  //     recordProperty.Name === 'Quantity' &&
  //     new Date(headerDueDate) >= new Date()
  //   ) {
  //     requestedDeliveryDate = new Date(headerDueDate);
  //   }

  //   //console.log(treeType);

  //   if (treeType == 'I' || treeType == 'iIngredient') {
  //     deliverProp.ValueAsObject = '';
  //     return;
  //   }
  //   if (!(treeType == 'S' || treeType == 'iSalesTree') && InvntItem == 'N') {
  //     deliverProp.ValueAsObject = '';
  //     return;
  //   }

  //   // Build additionalCommittedQuantities from other lines (excluding current line)
  //   let additionalCommittedQuantities = [];
  //   let lines = lineCat.Lines;
  //   let quantities = 0;

  //   lines.forEach(function (line) {
  //     if (line.Id !== e.line) {
  //       let lineItemCodeProp = line.Properties.find(
  //         (p) => p.Name === 'ItemCode'
  //       );
  //       let lineItemCode = lineItemCodeProp
  //         ? lineItemCodeProp.ValueAsObject
  //         : null;

  //       // Get U_ITM_DELIVER_SCHEDULE from the line
  //       let lineDeliverProp = line.Properties.find(
  //         (p) => p.Name === 'U_ITM_DELIVER_SCHEDULE'
  //       );
  //       let lineDeliverScheduleJson = lineDeliverProp
  //         ? lineDeliverProp.ValueAsObject
  //         : null;

  //       if (lineItemCode && lineDeliverScheduleJson) {
  //         try {
  //           // Parse the JSON from U_ITM_DELIVER_SCHEDULE
  //           let lineDeliverSchedule = JSON.parse(lineDeliverScheduleJson);

  //           // lineDeliverSchedule is expected to be an array of schedule suggestions
  //           lineDeliverSchedule.forEach(function (schedule) {
  //             // Extract Quantity and Date from the schedule
  //             let scheduleQuantity = schedule.Quantity;
  //             let scheduleDate = schedule.DeliveryDate;

  //             if (schedule.ComponentAllocations) {
  //               schedule.ComponentAllocations.forEach(function (
  //                 componentAllocations
  //               ) {
  //                 additionalCommittedQuantities.push({
  //                   ItemCode: componentAllocations.ComponentCode,
  //                   Quantity: componentAllocations.QuantityAllocated,
  //                   Date: scheduleDate,
  //                 });
  //               });
  //             }

  //             additionalCommittedQuantities.push({
  //               ItemCode: lineItemCode,
  //               Quantity: scheduleQuantity,
  //               Date: scheduleDate,
  //             });
  //           });
  //         } catch (ex) {
  //           console.error('Error parsing U_ITM_DELIVER_SCHEDULE JSON:', ex);
  //         }
  //       }
  //     }
  //   });

  //   // Exclude current line quantities
  //   let excludedCommittedQuantities = [];

  //   if (itemCode && quantity > 0 && deliverProp && deliverProp.ValueAsObject) {
  //     try {
  //       // Parse the JSON from U_ITM_DELIVER_SCHEDULE of the current line
  //       let deliverSchedule = JSON.parse(deliverProp.ValueAsObject);

  //       deliverSchedule.forEach(function (schedule) {
  //         let scheduleQuantity = schedule.Quantity;
  //         let scheduleDate = schedule.DeliveryDate;
  //         //shipDateProp.ValueAsObject = scheduleDate;
  //         quantities += schedule.Quantity;

  //         if (scheduleQuantity != 0 && schedule.ComponentAllocations != null) {
  //           schedule.ComponentAllocations.forEach(function (
  //             componentAllocations
  //           ) {
  //             componentAllocations.POAllocations.forEach(function (
  //               poAllocations
  //             ) {
  //               excludedCommittedQuantities.push({
  //                 ItemCode: componentAllocations.ComponentCode,
  //                 Quantity: poAllocations.QuantityAllocated,
  //                 Date: scheduleDate,
  //               });
  //             });
  //           });

  //           excludedCommittedQuantities.push({
  //             ItemCode: itemCode,
  //             Quantity: scheduleQuantity,
  //             Date: scheduleDate,
  //           });
  //         }
  //       });
  //     } catch (ex) {
  //       console.error(
  //         'Error parsing U_ITM_DELIVER_SCHEDULE JSON for current line:',
  //         ex
  //       );
  //     }
  //   }

  //   if (quantities === quantity && e.recordProperty.Name !== 'ShipDate') {
  //     return;
  //   }

  //   // Build the payload
  //   let payload = {
  //     ItemCode: itemCode,
  //     Quantity: quantity,
  //     LineNum: lineNumProp.ValueAsObject,
  //     DocEntry: docEntryProp.ValueAsObject,
  //     RequestedDeliveryDate: (function () {
  //       let date = new Date(requestedDeliveryDate);
  //       // Get the date components (Year, Month, Day)
  //       let year = date.getFullYear();
  //       let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so adding 1
  //       let day = String(date.getDate()).padStart(2, '0');
  //       return `${year}-${month}-${day}`;
  //     })(),
  //     AdditionalCommittedQuantities: additionalCommittedQuantities,
  //     ExcludedCommittedQuantities: excludedCommittedQuantities,
  //   };

  //   let jsonToPush = JSON.stringify(payload);
  //   let actionCode = 'GetDeliveryScheduleSuggestion';

  //   // Make the AJAX request to the backend
  //   this.layoutService
  //     .pushDataToBackend(jsonToPush, actionCode, jsonToPush)
  //     .subscribe((data: any) => {
  //       //console.log('data', data);
  //       if (!data.Has_Error && data.Resault_Value) {
  //         deliverProp.ValueAsObject = data.Resault_Value;

  //         var deliverSchedule = JSON.parse(deliverProp.ValueAsObject);
  //         deliverSchedule.forEach(function (schedule) {
  //           var scheduleDate = schedule.DeliveryDate;
  //           if (
  //             moment(shipDateProp.ValueAsObject).format('YYYY-MM-DD') !==
  //               moment(scheduleDate).format('YYYY-MM-DD') &&
  //             e.recordProperty.Name === 'ShipDate'
  //           ) {
  //             if (
  //               g.autoDisplayDeliverSchedule ||
  //               g.autoDisplayDeliverScheduleForShipDate
  //             ) {
  //               documents.DisplayDeliverScheduleDrawer(e, true);
  //             }
  //           }
  //           shipDateProp.ValueAsObject = scheduleDate;

  //           documents.layoutService.triggerBomParentFieldValueChanged({
  //             recordModel: e.recordModel,
  //             recordProperty: shipDateProp,
  //             formId: '',
  //             line: e.line,
  //             sectionTagName: e.sectionTagName,
  //             moduleStructure: e.moduleStructure,
  //           });

  //           documents.layoutService.triggerFieldValueChanged({
  //             recordModel: e.recordModel,
  //             recordProperty: deliverProp,
  //             formId: '',
  //             line: e.line,
  //             sectionTagName: e.sectionTagName,
  //             moduleStructure: e.moduleStructure,
  //           });

  //           if (
  //             recordLineOfField.Properties.find(
  //               (p) => p.Name === 'U_ITM_CHANGED'
  //             ) != null &&
  //             recordLineOfField.Properties.find(
  //               (p) => p.Name === 'U_ITM_CHANGED'
  //             ) !== undefined
  //           ) {
  //             recordLineOfField.Properties.find(
  //               (p) => p.Name === 'U_ITM_CHANGED'
  //             ).Value = 'Y';
  //             recordLineOfField.Properties.find(
  //               (p) => p.Name === 'U_ITM_CHANGED'
  //             ).ValueAsObject = 'Y';
  //           }

  //           return;
  //         });
  //       } else {
  //         if (!deliverProp && deliverProp !== undefined) {
  //           deliverProp.ValueAsObject = '';
  //         }
  //       }
  //     });
  // }

  GrossPriceChanged(args: FieldValueChangedArgs, onload: boolean = false) {
    /*if ($(sender).attr('inner-event') != undefined && $(sender).attr('inner-event') == 'true') {
      return;
    }*/
    const documentsSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );
    const element = documentLinesSection.Lines.find((l) => l.Id === args.line);

    const unitPriceText = element.Properties.find(
      (prop) => prop.Name === 'UnitPrice'
    ).ValueAsObject;
    let unitprice = this.getNumberValue(unitPriceText);

    const discountText = element.Properties.find(
      (prop) => prop.Name === 'DiscountPercent'
    ).ValueAsObject;
    let discount = this.getNumberValue(discountText);

    const VatGroupCodeEle = element.Properties.find(
      (prop) => prop.Name === 'TaxCode' || prop.Name === 'VatGroup'
    );

    let VatGroupCode = '';
    if (VatGroupCodeEle !== undefined) {
      VatGroupCode = element.Properties.find(
        (prop) => prop.Name === 'TaxCode' || prop.Name === 'VatGroup'
      ).ValueAsObject;
    }

    const grossPriceText = element.Properties.find(
      (prop) => prop.Name === 'PriceAfterVAT'
    ).ValueAsObject;
    const grossPrice = this.getNumberValue(grossPriceText);

    const postingDate = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDate'
    )?.ValueAsObject;

    const taxValue = Number(this.GetTaxRate(VatGroupCode, postingDate));

    /*$('select, input, textarea', row).each(function () {
      $(this).attr('inner-event', 'true');
    });*/

    // tslint:disable-next-line: letiable-name
    let total_LC = 0;
    // if
    total_LC = grossPrice * (100 / (100 + taxValue));
    // else // inbolsa
    if (Documents.reverseCalculation) {
      total_LC = grossPrice - (grossPrice * taxValue) / 100;
    }

    const docType = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    ).Lines[0].Properties.find((z) => z.Name === 'DocType').ValueAsObject;
    const baseType = element.Properties.find(
      (x) => x.Name.toLowerCase() == 'basetype'
    ).ValueAsObject;

    if (unitprice === 0 || docType === 'S' || g.grossPriceChangeResetDiscount) {
      unitprice = total_LC;
      discount = 0;
    } else if (baseType == null || baseType == '' || baseType == '-1') {
      let CalcDis;
      CalcDis = (1 - total_LC / unitprice) * 100;
      discount = CalcDis;
    } else {
      // let CalcDis;
      // CalcDis = (1 - total_LC / unitprice) * 100;
      // discount = CalcDis;
    }

    // next condition commented because the unit price will not be changed if the document
    // was in update mode, and this case is not proper for the documents of service type

    // if (args.recordModel.EventType === EventType.Update) {
    //   return;
    // }

    let fieldToUpdate = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'UnitPrice');
    if (fieldToUpdate.ValueAsObject !== unitprice.toString()) {
      LayoutService.setValue(
        fieldToUpdate,
        unitprice,
        this.layoutService,
        args.recordModel,
        args.line,
        'Document_Lines',
        args.moduleStructure
      );
    }

    fieldToUpdate = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'DiscountPercent');

    if (fieldToUpdate.ValueAsObject !== discount.toString() && discount !== 0) {
      LayoutService.setValue(
        fieldToUpdate,
        discount,
        this.layoutService,
        args.recordModel,
        args.line,
        'Document_Lines',
        args.moduleStructure
      );
    }

    /*$('select, input, textarea', row).each(function () {
      $(this).attr('inner-event', 'false');
    });*/

    // console.log('TaxPropertyName ======> ' + TaxPropertyName);
    // DocumentChangeLineTax($(sender).closest('[line]').find(TaxPropertyName), false, false);
    this.DocumentChangeLineTax(args, onload, false);
  }

  oDocuments_GetTotals(
    recordModel: RecordModel,
    moduleStructure: ModuleStructure,
    onload: boolean = false
  ) {
    if (
      recordModel.ObjectKey === 'oInventoryGenExit' ||
      recordModel.ObjectKey === 'oInventoryGenEntry'
    ) {
      return;
    }
    const calcTotalAccordingToQty = g.calcTotalAccordingToQty; //  should be a global letiable.
    const documentsSection = recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const docCurrency = documentsSection.Lines[0].Properties.find(
      (x) => x.Name == 'DocCurrency'
    );

    const documentLinesSection = recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );
    const docType = recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    ).Lines[0].Properties.find((x) => x.Name === 'DocType')
      .ValueAsObject as string;
    let total = 0;
    let grossTotal = 0;

    documentLinesSection.Lines.forEach((element) => {
      const unitPriceText = element.Properties.find(
        (prop) => prop.Name === 'UnitPrice'
      )?.ValueAsObject;
      const discountText = element.Properties.find(
        (prop) => prop.Name === 'DiscountPercent'
      )?.ValueAsObject;
      const exchangeRateText = this.GetLinesExchangeRate();

      let quantityText = '';
      if (docType === 'dDocument_Service' || docType.toLowerCase() === 's') {
        quantityText = '1';
      } else {
        quantityText = element.Properties.find(
          (prop) => prop.Name === 'Quantity'
        )?.ValueAsObject;
      }

      const taxOnlyProp = element.Properties.find(
        (prop) => prop.Name === 'TaxOnly'
      );
      let taxOnly = false;
      if (taxOnlyProp != null) {
        taxOnly = taxOnlyProp.ValueAsObject === 'Y';
      }

      let exchangeRate = Number(exchangeRateText);
      // let __type = $('[name="Document_Lines.TreeType"]', container).val();

      if (exchangeRate < 0) {
        // ShowMessage('error', translate('There is no exchange rate.'));
      }
      if (exchangeRate === 0 || exchangeRate === 0.5) {
        exchangeRate = 1;
      }

      let unitPrice = Number(unitPriceText) / exchangeRate;
      if (isNaN(unitPrice)) {
        unitPrice = 0;
      }

      let discount = Number(discountText);
      if (isNaN(discount) || discount > 100) {
        discount = 0;
      }
      const cur = g.companyConfiguration;
      const quantity = Number(quantityText);
      const unitPriceAfterDiscount = unitPrice - (unitPrice * discount) / 100;

      if (!taxOnly) {
        if (calcTotalAccordingToQty) {
          total += quantity * unitPriceAfterDiscount;
        } else {
          let lineTotalText = '';
          if (
            docType === 'dDocument_Service' ||
            docType.toLowerCase() === 's'
          ) {
            lineTotalText = element.Properties.find(
              (x) => x.Name === 'LineTotal'
            )?.ValueAsObject;
          } else {
            lineTotalText = element.Properties.find(
              (prop) => prop.Name === 'LineTotal'
            )?.ValueAsObject;
          }
          let unitPriceToAdd = Number(lineTotalText);
          if (unitPrice === 0) {
            unitPriceToAdd = 0;
          }

          if (
            element.Properties.find((prop) => prop.Name === 'LineType') ==
              undefined ||
            element.Properties.find((prop) => prop.Name === 'LineType')
              ?.ValueAsObject == 'R'
          ) {
            total += unitPriceToAdd; // quantity * unitPriceAfterDiscount;
          }
        }

        const priceAfterVatText = element.Properties.find(
          (prop) => prop.Name === 'PriceAfterVAT'
        )?.ValueAsObject;

        if (
          priceAfterVatText !== undefined &&
          element.Properties.find((prop) => prop.Name === 'LineType') ==
            undefined &&
          element.Properties.find((prop) => prop.Name === 'LineType')
            ?.ValueAsObject == 'R'
        ) {
          grossTotal += Number(priceAfterVatText) * Number(quantityText);
        }
      }
    });

    // tomchange
    const docRate = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocRate'
    )?.ValueAsObject;
    if (docRate === undefined || docRate === '') {
      LayoutService.setValue(
        documentsSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'TotalBeforeDiscount'
        ),
        0,
        this.layoutService,
        recordModel,
        0,
        'Documents',
        moduleStructure
      );
    } else {
      LayoutService.setValue(
        documentsSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'TotalBeforeDiscount'
        ),
        total,
        this.layoutService,
        recordModel,
        0,
        'Documents',
        moduleStructure
      );
    }

    return total;
  }

  oDocuments_UpdateTaxSum(args: FieldValueChangedArgs, onLoad: boolean) {
    if (
      args.recordModel.ObjectKey === 'oInventoryGenExit' ||
      args.recordModel.ObjectKey === 'oInventoryGenEntry'
    ) {
      return;
    }
    const documentsSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );
    const DocumentsAdditionalExpenses = args.recordModel.Categories.find(
      (x) => x.Id === 'DocumentsAdditionalExpenses'
    );
    let totalFreightTax = 0.0;
    let totalFreightAmount = 0.0;
    const taxTotal = this.oDocuments_GetTaxTotal(args, onLoad);

    const postingDate = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocDate'
    )?.ValueAsObject;

    if (DocumentsAdditionalExpenses != null) {
      DocumentsAdditionalExpenses.Lines.forEach((element) => {
        const freightAmountObj = element.Properties.find(
          (x) => x.Name === 'LineTotal'
        );
        const freightAmount = freightAmountObj
          ? freightAmountObj.ValueAsObject
          : 0;

        const vatGroupObj = element.Properties.find(
          (x) => x.Name === 'VatGroup'
        );
        let vatGroup;
        if (vatGroupObj == null) {
          vatGroup = element.Properties.find(
            (x) => x.Name === 'TaxCode'
          )?.ValueAsObject;
        } else {
          vatGroup = vatGroupObj.ValueAsObject;
        }
        const taxRate = this.GetTaxRate(vatGroup, postingDate);
        totalFreightTax += (freightAmount * taxRate) / 100;
        totalFreightAmount += freightAmount;
      });
    }
    const totalFreight = this.GetTotalFreight(
      documentLinesSection,
      postingDate
    );

    totalFreightTax += totalFreight.totalFreightTax;
    totalFreightAmount += totalFreight.totalFreightAmount;
    let taxValue = taxTotal; //  $('[name="Documents.VatSum"]', form).val().itmToNumber();
    let discountStr = '0';
    const linesTotal =
      this.oDocuments_GetTotals(args.recordModel, args.moduleStructure) -
      taxValue;
    const downPayment = 0; //  itmToNumber($('[name="Documents.ITM_DPM_AMOUNT"]', $form).val());

    const discountStrEle = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalDiscount'
    );

    if (discountStrEle !== undefined) {
      discountStr = discountStrEle.ValueAsObject;
    }

    if (discountStr == null || discountStr === undefined) {
      discountStr = '0';
    }
    let discount = Number(discountStr);
    if (isNaN(discount)) {
      discount = 0;
    }
    if (linesTotal - discount !== 0) {
      taxValue =
        taxValue -
        (taxValue * downPayment) / (linesTotal - discount) +
        totalFreightTax;
    } else if (totalFreightTax > 0) {
      taxValue = totalFreightTax;
    }

    // tomchange
    const docRate = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DocRate'
    )?.ValueAsObject;
    // console.log({ 'TaxValue': TaxValue });
    if (totalFreightAmount != null) {
      LayoutService.setValue(
        documentsSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'TotalFrieght'
        ),
        totalFreightAmount,
        this.layoutService,
        args.recordModel,
        0,
        'Documents',
        args.moduleStructure
      );
    }
    if (docRate === undefined || docRate === '') {
      LayoutService.setValue(
        documentsSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'VatSum'
        ),
        0,
        this.layoutService,
        args.recordModel,
        0,
        'Documents',
        args.moduleStructure
      );
    } else {
      LayoutService.setValue(
        documentsSection.Lines[0].Properties.find(
          (prop) => prop.Name === 'VatSum'
        ),
        taxValue,
        this.layoutService,
        args.recordModel,
        0,
        'Documents',
        args.moduleStructure
      );
    }
  }
  GetTotalFreight(documentLinesSection: RecordCategory, postingDate) {
    let totalFreightTax = 0.0;
    let totalFreightAmount = 0.0;
    documentLinesSection.Lines.forEach((element) => {
      for (let index = 1; index <= 3; index++) {
        const freightAmountObj = element.Properties.find(
          (x) => x.Name === `Freight${index}Amount`
        );
        const freightAmount = freightAmountObj
          ? freightAmountObj.ValueAsObject
          : 0;
        const freightTaxObj = element.Properties.find(
          (x) => x.Name === `Freight${index}VAT`
        );
        const freightTax = freightTaxObj
          ? this.GetTaxRate(freightTaxObj.ValueAsObject, postingDate)
          : 0;
        if (freightTax != null && freightAmount != null) {
          totalFreightTax += (+freightAmount * +freightTax) / 100;
          totalFreightAmount += +freightAmount;
        }
      }
    });
    return { totalFreightAmount, totalFreightTax };
  }
  oDocuments_GetTaxTotal(args: FieldValueChangedArgs, onLoad: boolean) {
    if (
      args.recordModel.ObjectKey === 'oInventoryGenExit' ||
      args.recordModel.ObjectKey === 'oInventoryGenEntry'
    ) {
      return;
    }
    const docType = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    ).Lines[0].Properties.find((x) => x.Name === 'DocType')?.ValueAsObject;
    const documentsSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );

    let DocDisc = 0;
    const discountObj = documentsSection.Lines[0].Properties.find(
      (prop) => prop.Name === 'DiscountPercent'
    );
    const discountValue = discountObj ? discountObj.ValueAsObject : 0;
    if (discountValue === undefined || discountValue === null) {
      DocDisc = 0;
    }
    DocDisc = Number(discountValue);

    let total = 0;
    let Tax = 0;

    if (onLoad) {
      // console.log('inside onload');
      documentLinesSection.Lines.forEach((element) => {
        let totalLineStr = '';
        let totalLine = 0;

        const taxCodeEle = element.Properties.find(
          (prop) => prop.Name === 'TaxCode' || prop.Name === 'VatGroup'
        );

        let taxCode = '';
        if (taxCodeEle !== undefined) {
          taxCode = taxCodeEle.ValueAsObject;
        }
        if (docType === 'dDocument_Service' || docType.toLowerCase() === 's') {
          totalLineStr = element.Properties.find(
            (x) => x.Name === 'LineTotal'
          )?.ValueAsObject;
        } else {
          totalLineStr = element.Properties.find(
            (prop) => prop.Name === 'LineTotal'
          ).ValueAsObject;
        }
        if (totalLineStr === undefined || totalLineStr === '') {
          totalLine = 0;
        } else {
          totalLine = Number(totalLineStr);
        }

        if (isNaN(totalLine) || totalLine === undefined) {
          totalLine = 0;
        }
        let oneTax = 0;
        if (taxCode !== '') {
          // console.log('inside onload>>', taxCode);
          if (
            element.Properties.find((prop) => prop.Name === 'TaxValue') != null
          ) {
            oneTax = element.Properties.find(
              (prop) => prop.Name === 'TaxValue'
            ).ValueAsObject;

            Tax = Tax + oneTax;
          }

          // const postingDate = documentsSection.Lines[0].Properties.find(
          //   (prop) => prop.Name === 'DocDate'
          // ).ValueAsObject;

          // const TaxValue = this.GetTaxRate(taxCode, postingDate);
          // let oneTax = (totalLine * TaxValue) / 100; /* docRate*/
          // const docRate = documentsSection.Lines[0].Properties.find(
          //   (prop) => prop.Name === 'DocRate'
          // ).ValueAsObject;

          // //Noor added this
          // if (Documents.reverseCalculation) {
          //   oneTax =
          //     // console.log('inside onload>>', Tax);
          //     ((totalLine / docRate / (1 - TaxValue / 100)) * TaxValue) / 100;
          // }

          // console.log(
          //   'Documents.reverseCalculation: ' + Documents.reverseCalculation
          // );
          // console.log('Documents.oneTax: ' + oneTax);

          // if (
          //   element.Properties.find((prop) => prop.Name === 'LineType') ==
          //     undefined ||
          //   element.Properties.find((prop) => prop.Name === 'LineType')
          //     ?.ValueAsObject == 'R'
          // ) {
          //   Tax = Tax + oneTax - (oneTax * DocDisc) / 100;
          // }

          if (
            element.Properties.find((prop) => prop.Name === 'LineType') ==
              undefined ||
            element.Properties.find((prop) => prop.Name === 'LineType')
              ?.ValueAsObject == 'R'
          ) {
            total = total + totalLine;
          }
          LayoutService.setValue(
            element.Properties.find((prop) => prop.Name === 'TaxValue'),
            oneTax,
            this.layoutService,
            args.recordModel,
            element.Id,
            'Document_Lines',
            args.moduleStructure
          );
        } else {
          if (
            element.Properties.find((prop) => prop.Name === 'LineType') ==
              undefined ||
            element.Properties.find((prop) => prop.Name === 'LineType')
              ?.ValueAsObject == 'R'
          ) {
            total += totalLine;
          }
        }
      });
    } else {
      // console.log('inside not onload');
      documentLinesSection.Lines.forEach((element) => {
        let totalLineStr = '';
        let totalLine = 0;

        const taxCodeEle = element.Properties.find(
          (prop) => prop.Name === 'TaxCode' || prop.Name === 'VatGroup'
        );

        let taxCode = '';
        if (taxCodeEle !== undefined) {
          taxCode = taxCodeEle.ValueAsObject;
        }
        if (docType === 'dDocument_Service' || docType.toLowerCase() === 's') {
          totalLineStr = element.Properties.find(
            (x) => x.Name === 'LineTotal'
          ).ValueAsObject;
        } else {
          totalLineStr = element.Properties.find(
            (prop) => prop.Name === 'LineTotal'
          )?.ValueAsObject;
        }
        if (totalLineStr === undefined || totalLineStr === '') {
          totalLine = 0;
        } else {
          totalLine = Number(totalLineStr);
        }

        if (isNaN(totalLine) || totalLine === undefined) {
          totalLine = 0;
        }

        if (taxCode !== '') {
          // console.log('inside onload>>', taxCode);
          const docRate = documentsSection.Lines[0].Properties.find(
            (prop) => prop.Name === 'DocRate'
          ).ValueAsObject;

          const postingDate = documentsSection.Lines[0].Properties.find(
            (prop) => prop.Name === 'DocDate'
          )?.ValueAsObject;

          const TaxValue = this.GetTaxRate(taxCode, postingDate);

          let oneTax = (totalLine * TaxValue) / 100; /* docRate*/

          // inbolsa
          if (Documents.reverseCalculation) {
            oneTax =
              ((totalLine / docRate / (1 - TaxValue / 100)) * TaxValue) / 100;
          }

          if (
            element.Properties.find((prop) => prop.Name === 'LineType') ==
              undefined ||
            element.Properties.find((prop) => prop.Name === 'LineType')
              ?.ValueAsObject == 'R'
          ) {
            Tax = Tax + oneTax - (oneTax * DocDisc) / 100;
          }
          // console.log('inside onload>>', Tax);
          total = total + totalLine;
          LayoutService.setValue(
            element.Properties.find((prop) => prop.Name === 'TaxValue'),
            oneTax,
            this.layoutService,
            args.recordModel,
            element.Id,
            'Document_Lines',
            args.moduleStructure
          );
        } else {
          total += totalLine;
        }
      });
    }

    total = total - total * (DocDisc / 100);

    return Tax;
  }

  DocumentChangeLineTax(
    args: FieldValueChangedArgs,
    onload: boolean = false,
    disableUpdateGrossPrice: boolean = true
  ) {
    if (disableUpdateGrossPrice === undefined) {
      disableUpdateGrossPrice = true;
    }

    if (disableUpdateGrossPrice === true) {
      if (args.sectionTagName === 'Documents') {
        return;
      }
      const GP = this.CalculateGrossPrice(args);
      this.SetGrossPrice(args, GP);
    }

    this.Document_UpdateRowTotal(args, onload);
  }

  oDocuments_GetTotalsGross(args: FieldValueChangedArgs): number {
    const documentsSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const calculateGrossPriceBasedOnLines = false; //  should be a global letiable
    const total = 0;
    let grossTotal = 0;

    if (calculateGrossPriceBasedOnLines === false) {
      const totalBeforeDiscountStr = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'TotalBeforeDiscount'
      )?.ValueAsObject;
      const vatSumStr = documentsSection.Lines[0].Properties.find(
        (prop) => prop.Name === 'VatSum'
      )?.ValueAsObject;

      if (totalBeforeDiscountStr !== undefined && vatSumStr !== undefined) {
        grossTotal = Number(totalBeforeDiscountStr) + Number(vatSumStr);
      }
    }

    return grossTotal;
  }

  GetTaxRate(taxCode: string, postingDate: string): number {
    let rateToReturn = 0;

    for (const tax of g.taxes) {
      if (taxCode !== '' && tax.Code === taxCode) {
        const taxEffectiveDate = new Date(tax.EffectiveDate);
        if (taxEffectiveDate <= new Date(postingDate)) {
          rateToReturn = tax.Rate;
        }
      }
    }

    return rateToReturn;
  }

  getNumberValue(strValue: string): number {
    if (strValue === undefined || strValue === '') {
      return 0;
    } else {
      return isNaN(Number(strValue)) ? 0 : Number(strValue);
    }
  }

  formatDatetime(date: Date, format: string) {
    const m = moment(date);

    return m.format(format);
  }

  getOptions(
    field: Field,
    sectionTagName: string,
    recordCategory: RecordCategory,
    lineId: number,
    recordProperty: RecordProperties,
    recordModel: RecordModel
  ) {
    const paramsNames = g.queriesData[field.SQLStatementId];
    const vals: string[] = [];

    if (paramsNames !== undefined) {
      for (const paramsName of paramsNames) {
        const sectionXmlTagName = paramsName.split('.')[0];
        const fieldPropertyName = paramsName.split('.')[1];

        if (sectionXmlTagName === sectionTagName) {
          let value = '';
          const recordLine = recordCategory.Lines[lineId];
          const currentRecordProperty = recordLine.Properties.find(
            (property) => property.Name === fieldPropertyName
          );

          if (currentRecordProperty != null) {
            value = currentRecordProperty.DBValue;
            if (value === undefined || value == null || value === '') {
              value = currentRecordProperty.ValueAsObject;
            }
          }

          vals.push(value);
        } else {
          let value = '';
          const currentRecordCategory = recordModel.Categories.find(
            (category) => category.Id === sectionXmlTagName
          );

          if (
            currentRecordCategory != null &&
            currentRecordCategory.Lines.length > 0
          ) {
            const recordLine = currentRecordCategory.Lines[0];
            const currentRecordProperty = recordLine.Properties.find(
              (property) => property.Name === fieldPropertyName
            );

            if (currentRecordProperty != null) {
              value = currentRecordProperty.DBValue;
              if (value === undefined || value == null || value === '') {
                value = currentRecordProperty.ValueAsObject;
              }
            }
          }
          vals.push(value);
        }
      }
    }

    this.layoutService
      .getSelectValues(
        null,
        field.AdditionalInformationParsed.DataSourcePath,
        field.Id,
        field.SQLStatementId,
        paramsNames,
        vals
      )
      .subscribe((d: any) => {
        recordProperty.Options = d.Values.rowsArray;
        /*for (let i = 0; i < this.options.length; i++) {
          if (this.options[i].DBValue != undefined) {
              this.options[i].Code = this.options[i].DBValue;
          }
      }*/

        if (
          recordProperty.Options !== undefined &&
          recordProperty.Options.length !== 0 &&
          recordProperty.Options[0].DBValue !== undefined
        ) {
          if (
            recordProperty.DBValue === '' &&
            recordProperty.ValueAsObject !== ''
          ) {
            recordProperty.DBValue = recordProperty.ValueAsObject;
            const option = recordProperty.Options.find(
              (opt) => opt.DBValue === recordProperty.DBValue
            );
            if (option !== undefined) {
              recordProperty.ValueAsObject = option.Code;
            }
          } else if (
            recordProperty.DBValue !== '' &&
            recordProperty.ValueAsObject === ''
          ) {
            const option = recordProperty.Options.find(
              (opt) => opt.DBValue === recordProperty.DBValue
            );
            if (option !== undefined) {
              recordProperty.ValueAsObject = option.Code;
            }
          }
        }
      });
  }

  oDocuments_TypeChanged(args: FieldValueChangedArgs) {
    setTimeout(() => {
      args.recordModel.Categories.find(
        (cat) => cat.Id == 'Document_Lines'
      ).Lines = [];
      if (args.recordProperty.ValueAsObject === 'dDocument_Items') {
        args.moduleStructure.module.Sections.find(
          (x) =>
            x.XmlTagName === 'Document_Lines' &&
            x.TitleForList.toLowerCase().includes('items')
        ).AdditionalInformationParsed.Hidden = false;
        args.moduleStructure.module.Sections.find(
          (x) =>
            x.XmlTagName === 'Document_Lines' &&
            x.TitleForList.toLowerCase().includes('services')
        ).AdditionalInformationParsed.Hidden = true;
      } else {
        args.moduleStructure.module.Sections.find(
          (x) =>
            x.XmlTagName === 'Document_Lines' &&
            x.TitleForList.toLowerCase().includes('items')
        ).AdditionalInformationParsed.Hidden = true;
        args.moduleStructure.module.Sections.find(
          (x) =>
            x.XmlTagName === 'Document_Lines' &&
            x.TitleForList.toLowerCase().includes('services')
        ).AdditionalInformationParsed.Hidden = false;
      }

      LayoutService.setValue(
        args.recordProperty,
        args.recordProperty.ValueAsObject,
        this.layoutService,
        args.recordModel,
        args.line,
        args.sectionTagName,
        args.moduleStructure
      );
      this.layoutService.moduleStructureChanged.emit();
    }, 500);
  }

  updateDiscount(args: FieldValueChangedArgs) {
    const document = args.recordModel.Categories.find(
      (x) => x.Id === 'Documents'
    );
    const documentLinesSection = args.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines'
    );
    const propertyLine = documentLinesSection.Lines.find(
      (l) => l.Id === args.line
    );
    let quantity = propertyLine.Properties.find(
      (x) => x.Name === 'Quantity'
    ).ValueAsObject;
    const unitPrice = propertyLine.Properties.find(
      (x) => x.Name === 'UnitPrice'
    ).ValueAsObject;
    const lineTotal = args.recordProperty.ValueAsObject;
    let rate = propertyLine.Properties.find(
      (x) => x.Name === 'Rate'
    )?.ValueAsObject;
    rate = rate === '' || rate == null ? 1 : rate;
    quantity =
      quantity === '' || quantity == null || quantity === 0 ? 1 : quantity;
    const discPercent =
      ((+quantity * +unitPrice - +lineTotal * rate) * 100) /
      (+quantity * +unitPrice);
    if (isNaN(discPercent)) {
      return;
    }
    LayoutService.setValue(
      propertyLine.Properties.find((x) => x.Name === 'DiscountPercent'),
      discPercent,
      this.layoutService,
      args.recordModel,
      args.line,
      args.sectionTagName,
      args.moduleStructure
    );
  }
}
